export const lang = {
  // 按钮文言
  btn: {
    /** *****************共通********************/
    searchBtn: '查询',
    detailBtn: '详情',
    deleteBtn: '删除',
    modifyBtn: '修改',
    /** *****************共通********************/
  },
  // placeholder
  plh: {

    /** *****************共通start********************/
    sel: '请选择',
    /** *****************共通end********************/
    /** *************发帖审核页面start******************/
    adsKey: '请输入发帖人搜索',
    /** *************发帖审核页面end******************/
    input: '请输入',

  },
  // 首页图标
  lab_addQuickEntry: '添加快捷入口',
  lab_myCollection: '我的收藏',
  imgList: [{
      id: '0',
      name: '添加快捷入口',
      path: '',
      url: require('../../assets/imgs/add.png'),
    },
    // {
    //   id: '4',
    //   name: '业主通知',
    //   path: 'main.unotice',
    //   url_green: require('../../assets/imgs/xqfw1.png'),
    //   url_pink: require('../../assets/imgs/xqfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqfw3.png'),
    // },
    // {
    //   id: '5',
    //   name: '业主私信',
    //   path: 'main.privateLetter',
    //   url_green: require('../../assets/imgs/xqfw1.png'),
    //   url_pink: require('../../assets/imgs/xqfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqfw3.png'),
    // },
    {
      id: '6',
      name: '菜单管理',
      path: 'main.munuManager',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '7',
      name: '职责管理',
      path: 'main.authorityList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '8',
      name: '角色管理',
      path: 'main.roleList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '10',
      name: '报事信息',
      path: 'main.maintainInfo',
      url_green: require('../../assets/imgs/menuIcon1.png'),
      url_pink: require('../../assets/imgs/menuIcon1.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon1.png'),
    },
    {
      id: '11',
      name: '项目管理',
      path: 'main.gardensManage',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '13',
      name: '物业信用积分体系',
      path: 'main.creditScore',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '14',
      name: '园区鹰眼接口',
      path: 'main.videoMonitorInterface',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '15',
      name: '居家服务提成设置',
      path: 'main.serviceCommissionExtract',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '17',
    //   name: '物业公司架构组织',
    //   path: 'main.orgDepartment',
    //   url_green: require('../../assets/imgs/gsgl1.png'),
    //   url_pink: require('../../assets/imgs/gsgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/gsgl3.png'),
    // },
    {
      id: '18',
      name: '全项目自动巡检报事',
      path: 'main.allMaintainQuartzJob',
      url_green: require('../../assets/imgs/menuIcon2.png'),
      url_pink: require('../../assets/imgs/menuIcon2.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon2.png'),
    },
    {
      id: '21',
      name: '全项目报事信息',
      path: 'main.allMaintain',
      url_green: require('../../assets/imgs/menuIcon3.png'),
      url_pink: require('../../assets/imgs/menuIcon3.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon3.png'),
    },
    {
      id: '23',
      name: '400报事信息',
      path: 'main.maintainInfo400',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '24',
      name: '报事类型设置',
      path: 'main.maintainType1',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '25',
      name: '首页广告管理',
      path: 'main.pivot0',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '26',
    //   name: '众乐汇广告管理',
    //   path: 'main.pivot2',
    //   url_green: require('../../assets/imgs/gggl1.png'),
    //   url_pink: require('../../assets/imgs/gggl2.png'),
    //   url_bluegreen: require('../../assets/imgs/gggl3.png'),
    // },
    // {
    //   id: '27',
    //   name: '邻里帮广告管理',
    //   path: 'main.pivot3',
    //   url_green: require('../../assets/imgs/gggl1.png'),
    //   url_pink: require('../../assets/imgs/gggl2.png'),
    //   url_bluegreen: require('../../assets/imgs/gggl3.png'),
    // },
    // {
    //   id: '28',
    //   name: '众乐商品管理',
    //   path: 'main.good',
    //   url_green: require('../../assets/imgs/spgl1.png'),
    //   url_pink: require('../../assets/imgs/spgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/spgl3.png'),
    // },
    // {
    //   id: '29',
    //   name: '订单管理',
    //   path: 'main.orderManage',
    //   url_green: require('../../assets/imgs/spgl1.png'),
    //   url_pink: require('../../assets/imgs/spgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/spgl3.png'),
    // },
    // {
    //   id: '30',
    //   name: '积分管理',
    //   path: 'main.pointManage',
    //   url_green: require('../../assets/imgs/spgl1.png'),
    //   url_pink: require('../../assets/imgs/spgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/spgl3.png'),
    // },
    // {
    //   id: '31',
    //   name: '积分广告',
    //   path: 'main.pivot1',
    //   url_green: require('../../assets/imgs/gggl1.png'),
    //   url_pink: require('../../assets/imgs/gggl2.png'),
    //   url_bluegreen: require('../../assets/imgs/gggl3.png'),
    // },
    // {
    //   id: '32',
    //   name: '抽奖管理',
    //   path: 'main.lotteries',
    //   url_green: require('../../assets/imgs/spgl1.png'),
    //   url_pink: require('../../assets/imgs/spgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/spgl3.png'),
    // },
    // {
    //   id: '33',
    //   name: '用后感',
    //   path: 'main.testimonialsManage',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '34',
    //   name: '链接管理',
    //   path: 'main.linkManage',
    //   url_green: require('../../assets/imgs/staticIcon.png'),
    //   url_pink: require('../../assets/imgs/staticIcon.png'),
    //   url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    // },
    // {
    //   id: '36',
    //   name: '业主私信',
    //   path: 'main.privateLetter',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    {
      id: '38',
      name: '业主端logo管理',
      path: 'main.logo',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '39',
      name: 'APP版本管理',
      path: 'main.version',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '40',
      name: '物业知识库分类管理',
      path: 'main.knowledgeType',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '42',
      name: '物业知识库检索查询',
      path: 'main.knowledge',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '43',
    //   name: '服务建议部门管理',
    //   path: 'main.assessTypeList',
    //   url_green: require('../../assets/imgs/xqgl1.png'),
    //   url_pink: require('../../assets/imgs/xqgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqgl3.png'),
    // },
    // {
    //   id: '44',
    //   name: '服务建议查看',
    //   path: 'main.assessList',
    //   url_green: require('../../assets/imgs/xqgl1.png'),
    //   url_pink: require('../../assets/imgs/xqgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqgl3.png'),
    // },
    // {
    //   id: '45',
    //   name: '任务管理',
    //   path: 'main.quartzJobList',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    // {
    //   id: '46',
    //   name: '标语管理',
    //   path: 'main.sloganList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '48',
    //   name: '检查标准',
    //   path: 'main.patrolStandardList',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    {
      id: '49',
      name: '设备管理',
      path: 'main.deviceList',
      url_green: require('../../assets/imgs/menuIcon4.png'),
      url_pink: require('../../assets/imgs/menuIcon4.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon4.png'),
    },
    // {
    //   id: '50',
    //   name: '标签管理',
    //   path: 'main.tabList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '51',
    //   name: '人事信息',
    //   path: 'main.hrList',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    {
      id: '52',
      name: '抽审工单',
      path: 'main.randomInspectionMaintain',
      url_green: require('../../assets/imgs/menuIcon5.png'),
      url_pink: require('../../assets/imgs/menuIcon5.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon5.png'),
    },
    // {
    //   id: '53',
    //   name: '合同分类',
    //   path: 'main.contractType1',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    // {
    //   id: '54',
    //   name: '合同管理',
    //   path: 'main.contract',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    // {
    //   id: '55',
    //   name: '表扬/投诉',
    //   path: 'main.complainList',
    //   url_green: require('../../assets/imgs/xqgl1.png'),
    //   url_pink: require('../../assets/imgs/xqgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqgl3.png'),
    // },
    // {
    //   id: '56',
    //   name: '有偿服务分类',
    //   path: 'main.paidServiceType1',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    // {
    //   id: '57',
    //   name: '供应商',
    //   path: 'main.supplierList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '58',
    //   name: '平面图设置',
    //   path: 'main.planarGraphList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '59',
    //   name: '类型设置',
    //   path: 'main.patrolTypeList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '60',
    //   name: '人员分配',
    //   path: 'main.patrolPersonnelAllocationList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '61',
    //   name: '打印二维码',
    //   path: 'main.patrolPointList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '62',
    //   name: '异常记录',
    //   path: 'main.patrolExceptionList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '63',
    //   name: '有偿服务',
    //   path: 'main.paidServiceList',
    //   url_green: require('../../assets/imgs/xqfw1.png'),
    //   url_pink: require('../../assets/imgs/xqfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqfw3.png'),
    // },
    // {
    //   id: '64',
    //   name: '报表下载',
    //   path: 'main.tongji',
    //   url_green: require('../../assets/imgs/xqfw1.png'),
    //   url_pink: require('../../assets/imgs/xqfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqfw3.png'),
    // },
    // {
    //   id: '65',
    //   name: '项目日历',
    //   path: 'main.patrolList',
    //   url_green: require('../../assets/imgs/qt1.png'),
    //   url_pink: require('../../assets/imgs/qt2.png'),
    //   url_bluegreen: require('../../assets/imgs/qt3.png'),
    // },
    // {
    //   id: '66',
    //   name: '二手房房源管理',
    //   path: 'main.secondHandHouseHList',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    // {
    //   id: '67',
    //   name: '二手房客源管理',
    //   path: 'main.secondHandHousePList',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    // {
    //   id: '68',
    //   name: '电梯管理',
    //   path: 'main.maintainElevatorErrorList',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    {
      id: '69',
      name: '活动管理',
      path: 'main.activityList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '70',
      name: '机房设备管理',
      path: 'main.machineDeviceList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '71',
      name: '业主通知',
      path: 'main.unotice',
      url_green: require('../../assets/imgs/menuIcon6.png'),
      url_pink: require('../../assets/imgs/menuIcon6.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon6.png'),
    },
    {
      id: '72',
      name: '业主私信',
      path: 'main.privateLetter',
      url_green: require('../../assets/imgs/menuIcon1.png'),
      url_pink: require('../../assets/imgs/menuIcon1.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon1.png'),
    },
    {
      id: '73',
      name: '电话信息',
      path: 'main.contact',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '74',
      name: '项目信息管理',
      path: 'main.garden1',
      url_green: require('../../assets/imgs/menuIcon7.png'),
      url_pink: require('../../assets/imgs/menuIcon7.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon7.png'),
    },
    {
      id: '75',
      name: '原始住户数据管理',
      path: 'main.roomOwner',
      url_green: require('../../assets/imgs/menuIcon8.png'),
      url_pink: require('../../assets/imgs/menuIcon8.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon8.png'),
    },
    {
      id: '76',
      name: 'APP住户管理',
      path: 'main.user',
      url_green: require('../../assets/imgs/menuIcon9.png'),
      url_pink: require('../../assets/imgs/menuIcon9.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon9.png'),
    },
    {
      id: '77',
      name: '首页广告',
      path: 'main.pivot0',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '78',
    //   name: '邻里帮广告',
    //   path: 'main.pivot3',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    {
      id: '80',
      name: '周边服务',
      path: 'main.gardenservice',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '81',
    //   name: '发帖审核',
    //   path: 'main.topics',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    // {
    //   id: '82',
    //   name: '标签管理',
    //   path: 'main.tabList',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    {
      id: '83',
      name: '活动管理',
      path: 'main.activityList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '84',
      name: '全项目自动巡检报事',
      path: 'main.allMaintainQuartzJob',
      url_green: require('../../assets/imgs/menuIcon2.png'),
      url_pink: require('../../assets/imgs/menuIcon2.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon2.png'),
    },
    {
      id: '85',
      name: '全项目报事信息',
      path: 'main.allMaintain',
      url_green: require('../../assets/imgs/menuIcon3.png'),
      url_pink: require('../../assets/imgs/menuIcon3.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon3.png'),
    },
    {
      id: '86',
      name: '400报事信息',
      path: 'main.maintainInfo400',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '87',
      name: '园区鹰眼',
      path: 'main.supplyVideo',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '88',
      name: '物业知识库查询',
      path: 'main.knowledge',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '89',
      name: '居家服务劳动所得',
      path: 'main.serviceCommissionList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '90',
      name: '物业信用积分体系',
      path: 'main.creditScore',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '91',
    //   name: '服务建议查看',
    //   path: 'main.assessList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '92',
      name: '物业人员管理',
      path: 'main.staff',
      url_green: require('../../assets/imgs/menuIcon10.png'),
      url_pink: require('../../assets/imgs/menuIcon10.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon10.png'),
    },
    {
      id: '94',
      name: '任务管理',
      path: 'main.quartzJobList',
      url_green: require('../../assets/imgs/menuIcon2.png'),
      url_pink: require('../../assets/imgs/menuIcon2.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon2.png'),
    },
    {
      id: '95',
      name: '设备管理',
      path: 'main.deviceList',
      url_green: require('../../assets/imgs/menuIcon4.png'),
      url_pink: require('../../assets/imgs/menuIcon4.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon4.png'),
    },
    {
      id: '96',
      name: '抽审工单',
      path: 'main.randomInspectionMaintain',
      url_green: require('../../assets/imgs/menuIcon5.png'),
      url_pink: require('../../assets/imgs/menuIcon5.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon5.png'),
    },
    {
      id: '97',
      name: '合同管理',
      path: 'main.contract',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '98',
    //   name: '表扬/投诉',
    //   path: 'main.complainList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '99',
    //   name: '电梯管理',
    //   path: 'main.maintainElevatorErrorList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '100',
    //   name: '有偿服务',
    //   path: 'main.paidServiceList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '101',
      name: '机房设备管理',
      path: 'main.machineDeviceList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '102',
    //   name: '平面图设置',
    //   path: 'main.planarGraphList',
    //   url_green: require('../../assets/imgs/znxg1.png'),
    //   url_pink: require('../../assets/imgs/znxg2.png'),
    //   url_bluegreen: require('../../assets/imgs/znxg3.png'),
    // },
    // {
    //   id: '103',
    //   name: '类型设置',
    //   path: 'main.patrolTypeList',
    //   url_green: require('../../assets/imgs/znxg1.png'),
    //   url_pink: require('../../assets/imgs/znxg2.png'),
    //   url_bluegreen: require('../../assets/imgs/znxg3.png'),
    // },
    // {
    //   id: '104',
    //   name: '人员分配',
    //   path: 'main.patrolPersonnelAllocationList',
    //   url_green: require('../../assets/imgs/znxg1.png'),
    //   url_pink: require('../../assets/imgs/znxg2.png'),
    //   url_bluegreen: require('../../assets/imgs/znxg3.png'),
    // },
    // {
    //   id: '105',
    //   name: '打印二维码',
    //   path: 'main.patrolPointList',
    //   url_green: require('../../assets/imgs/znxg1.png'),
    //   url_pink: require('../../assets/imgs/znxg2.png'),
    //   url_bluegreen: require('../../assets/imgs/znxg3.png'),
    // },
    // {
    //   id: '106',
    //   name: '异常记录',
    //   path: 'main.patrolExceptionList',
    //   url_green: require('../../assets/imgs/znxg1.png'),
    //   url_pink: require('../../assets/imgs/znxg2.png'),
    //   url_bluegreen: require('../../assets/imgs/znxg3.png'),
    // },
    // {
    //   id: '107',
    //   name: '报表下载',
    //   path: 'main.tongji',
    //   url_green: require('../../assets/imgs/wysjfw1.png'),
    //   url_pink: require('../../assets/imgs/wysjfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wysjfw3.png'),
    // },
    {
      id: '108',
      name: '项目日历',
      path: 'main.patrolList',
      url_green: require('../../assets/imgs/menuIcon11.png'),
      url_pink: require('../../assets/imgs/menuIcon11.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon11.png'),
    },
    // {
    //   id: '109',
    //   name: '二手房房源管理',
    //   path: 'main.secondHandHouseHList',
    //   url_green: require('../../assets/imgs/zlzx1.png'),
    //   url_pink: require('../../assets/imgs/zlzx2.png'),
    //   url_bluegreen: require('../../assets/imgs/zlzx3.png'),
    // },
    // {
    //   id: '110',
    //   name: '二手房客源管理',
    //   path: 'main.secondHandHousePList',
    //   url_green: require('../../assets/imgs/zlzx1.png'),
    //   url_pink: require('../../assets/imgs/zlzx2.png'),
    //   url_bluegreen: require('../../assets/imgs/zlzx3.png'),
    // },
    {
      id: '113',
      name: '职务管理',
      path: 'main.jobList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '117',
      name: '居家服务劳动所得',
      path: 'main.serviceCommissionList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '118',
    //   name: '我的任务计划',
    //   path: 'main.planTask',
    //   url_green: require('../../assets/imgs/gzrw1.png'),
    //   url_pink: require('../../assets/imgs/gzrw2.png'),
    //   url_bluegreen: require('../../assets/imgs/gzrw3.png'),
    // },
    // {
    //   id: '134',
    //   name: '部门任务计划',
    //   path: 'main.deptPlanTask',
    //   url_green: require('../../assets/imgs/gzrw1.png'),
    //   url_pink: require('../../assets/imgs/gzrw2.png'),
    //   url_bluegreen: require('../../assets/imgs/gzrw3.png'),
    // },
    {
      id: '135',
      name: '门禁设备管理',
      path: 'main.doorDeviceList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '136',
      name: '系统代码参数',
      path: 'main.sysCode',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '139',
      name: '物业端logo管理',
      path: 'main.wylogo',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '140',
      name: '检查标准',
      path: 'main.patrolStandardList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '141',
      name: '众邻观点',
      path: 'main.courtroomList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '142',
      name: '资源台账',
      path: 'main.resourceLedgerList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '149',
      name: '合同分类',
      path: 'main.contractType1',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '150',
      name: '租客审批',
      path: 'main.tenantInfoManager',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '151',
    //   name: '服务评价',
    //   path: 'main.serviceEvaluation',
    //   url_green: require('../../assets/imgs/xqfw1.png'),
    //   url_pink: require('../../assets/imgs/xqfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/xqfw3.png'),
    // },
    {
      id: '154',
      name: '物业周检问题',
      path: 'main.weeklyInspectionList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '159',
    //   name: '门禁通知管理',
    //   path: 'main.doorDeviceNoticeList',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    {
      id: '160',
      name: '员工转单',
      path: 'main.staffAdjustment',
      url_green: require('../../assets/imgs/menuIcon12.png'),
      url_pink: require('../../assets/imgs/menuIcon12.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon12.png'),
    },
    {
      id: '161',
      name: '员工离职',
      path: 'main.staffLeave',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '162',
      name: 'APP梯控设备管理',
      path: 'main.liftList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '164',
      name: '问卷调查链接',
      path: 'main.questionnaireList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '165',
      name: '部门管理',
      path: 'main.dept',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '167',
      name: '业主端APP广告管理',
      path: 'main.doorDeviceNoticeList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '168',
      name: '项目空置房管理',
      path: 'main.gardenvacant1',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '173',
      name: '稽查跨区巡检',
      path: 'main.quartzJobListInspect',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '174',
      name: '物品管理',
      path: 'main.borrowingList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '175',
      name: '分类查看鹰眼',
      path: 'main.supplyVideoByType',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '176',
      name: '鹰眼分类',
      path: 'main.videoMonitorType',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '177',
      name: '视频管理',
      path: 'main.trainingVideoList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '178',
      name: '检查标准查看',
      path: 'main.patrolStandardLookList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '179',
    //   name: '物品管理',
    //   path: 'main.borrowingList',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    // {
    //   id: '183',
    //   name: '服务小站管理',
    //   path: 'main.appletsGoodList',
    //   url_green: require('../../assets/imgs/spgl1.png'),
    //   url_pink: require('../../assets/imgs/spgl2.png'),
    //   url_bluegreen: require('../../assets/imgs/spgl3.png'),
    // },
    {
      id: '184',
      name: '专属二维码',
      path: 'main.qrcode',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '185',
      name: 'APP布局',
      path: 'main.appplotList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '187',
      name: '车场管理',
      path: 'main.carPackList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '188',
      name: '试题库',
      path: 'main.exam_question',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '189',
      name: '试卷库',
      path: 'main.exam_paper',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '190',
      name: '成绩库',
      path: 'main.exam_result',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '191',
      name: '分类设置',
      path: 'main.exam_type',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '192',
      name: '车辆管理',
      path: 'main.carUserList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '193',
    //   name: '红色专区',
    //   path: 'main.redZone',
    //   rl_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    {
      id: '194',
      name: '月租车出入记录',
      path: 'main.carInOutList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '195',
      name: '电梯巡检计划任务',
      path: 'main.taskImport',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '196',
      name: 'UniApp版本管理',
      path: 'main.versionuniapp',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '197',
      name: '收费设置',
      path: 'main.feeConfig',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '198',
      name: '收取费用',
      path: 'main.feePay',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '199',
      name: '车辆发卡',
      path: 'main.carGateRuleList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '200',
      name: 'APP积分管理',
      path: 'main.integral',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '201',
      name: '车场监控',
      path: 'main.carParkControl',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '203',
    //   name: '投票管理',
    //   path: 'main.voteList',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    // {
    //   id: '207',
    //   name: '车位摇号审批',
    //   path: 'main.parkingLotteryManager',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    // {
    //   id: '209',
    //   name: '摇号车位管理',
    //   path: 'main.parkingLotteryPlaceManager',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    // {
    //   id: '211',
    //   name: '小店广告',
    //   path: 'main.sklGardenAd',
    //   url_green: require('../../assets/imgs/yzappfw1.png'),
    //   url_pink: require('../../assets/imgs/yzappfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/yzappfw3.png'),
    // },
    {
      id: '213',
      name: '管理员列表',
      path: 'main.adminList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '214',
      name: '集团管理',
      path: 'main.groupsManage',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '217',
      name: '管家区域配置',
      path: 'main.housekeepingArea',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '218',
      name: '应收查询',
      path: 'main.feeReceive',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '219',
      name: '实收查询',
      path: 'main.feeActual',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '220',
    //   name: '外拓信息',
    //   path: 'main.outSide',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '221',
      name: '生活家线下订单',
      path: 'main.appOrder',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '223',
      name: '商家优惠停车',
      path: 'main.payStop',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '225',
      name: '临时车出入记录',
      path: 'main.carInOutTmpList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '226',
      name: '车场日志',
      path: 'main.carRecordList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '228',
      name: '报表管理',
      path: 'main.feeReport',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '236',
      name: '资源点位类型管理',
      path: 'main.venueType',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '238',
    //   name: '集团官网审批',
    //   path: 'main.groupExamine',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '239',
      name: '储值车出入记录',
      path: 'main.carInOutStoreList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '240',
      name: '储值卡管理',
      path: 'main.carStoreList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '241',
    //   name: '集团网站维护',
    //   path: 'main.groupWebsite',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '242',
      name: '外部应用',
      path: 'main.zljexe',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '243',
      name: '门禁批量授权',
      path: 'main.doorDeviceRightBatch',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '244',
      name: '凭证模板',
      path: 'main.voucher',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '245',
    //   name: '公司新闻',
    //   path: 'main.wjNewsList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '247',
    //   name: '工作任务',
    //   path: 'main.wjTaskManageList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '248',
    //   name: '发卡管理',
    //   path: 'main.manageCardList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '249',
    //   name: '通行设备管理',
    //   path: 'main.xlDoorDevice',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '250',
    //   name: '任务标准',
    //   path: 'main.wjPatrolStandardList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '251',
    //   name: '任务标准查看',
    //   path: 'main.wjPatrolStandardLookList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '252',
    //   name: '密钥管理',
    //   path: 'main.secretManage',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '254',
      name: '梯控批量授权',
      path: 'main.liftRightBatch',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '259',
      name: '车辆发卡查询',
      path: 'main.carGateRuleList1',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '260',
    //   name: '访客预约审核',
    //   path: 'main.wjAppointmentExamine',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '262',
      name: '车场黑名单管理',
      path: 'main.carBlackList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '264',
    //   name: '人脸设备管理',
    //   path: 'main.woDeviceList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '265',
    //   name: '人像注册',
    //   path: 'main.woUser',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '266',
    //   name: '人脸识别授权',
    //   path: 'main.woUserAuth',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '271',
    //   name: '项目信息登记',
    //   path: 'main.projectPortrait',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '272',
      name: '车位数据管理',
      path: 'main.propertyCar',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '273',
      name: '房屋车位转让日志',
      path: 'main.transferLogs',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '274',
      name: '历史导入',
      path: 'main.feeInitialization',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '275',
      name: '临时车人工确认',
      path: 'main.carInOutTmpConfirmList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '276',
    //   name: '党建活动',
    //   path: 'main.partyActivityList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '277',
      name: '车场数据管理',
      path: 'main.carDataAll',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '278',
      name: '离职待处理工单',
      path: 'main.leaveUntreatedOrderList',
      url_green: require('../../assets/imgs/menuIcon13.png'),
      url_pink: require('../../assets/imgs/menuIcon13.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon13.png'),
    },
    // {
    //   id: '279',
    //   name: '实时监测',
    //   path: 'main.realTimeMonitoringList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '280',
    //   name: '电梯告警',
    //   path: 'main.elevatorAlarm',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '281',
    //   name: '设备列表',
    //   path: 'main.elevatorList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '282',
    //   name: '集中监测',
    //   path: 'main.focusMonitoringList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '283',
    //   name: 'Nas网络存储服务',
    //   path: 'main.serviceNas',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '284',
      name: '检查标准复制',
      path: 'main.copyPatrolStandardList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '285',
      name: '供应商管理',
      path: 'main.vesupplierList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '286',
      name: '合同管理',
      path: 'main.contractList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '287',
      name: '资源点位管理',
      path: 'main.venueList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '288',
      name: '园区数字画像',
      path: 'main.basicDataSummary',
      url_green: require('../../assets/imgs/menuIcon14.png'),
      url_pink: require('../../assets/imgs/menuIcon14.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon14.png'),
    },
    // {
    //   id: '289',
    //   name: '访客预约数据导出',
    //   path: 'main.wjAppointmentExamine1',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '295',
      name: '商家优惠减免',
      path: 'main.payStopDerate',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '296',
    //   name: '园区鹰眼监控',
    //   path: 'main.supplyVideo',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '297',
      name: 'APP门禁设备管理',
      path: 'main.doorDeviceList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '298',
      name: 'APP梯控设备管理',
      path: 'main.liftList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '299',
      name: '门禁批量授权',
      path: 'main.doorDeviceRightBatch',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '300',
      name: '梯控批量授权',
      path: 'main.liftRightBatch',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '301',
      name: '车主信息管理',
      path: 'main.addPreInfoCar',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '304',
    //   name: '知了教育活动管理',
    //   path: 'main.teachGroupList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '305',
      name: '报表统计',
      path: 'main.feeStatistics',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '306',
      name: '物业人员画像对比',
      path: 'main.staffSummaryPk',
      url_green: require('../../assets/imgs/menuIcon15.png'),
      url_pink: require('../../assets/imgs/menuIcon15.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon15.png'),
    },
    {
      id: '307',
      name: '园区数字画像对比',
      path: 'main.basicDataSummaryPk',
      url_green: require('../../assets/imgs/menuIcon14.png'),
      url_pink: require('../../assets/imgs/menuIcon14.png'),
      url_bluegreen: require('../../assets/imgs/menuIcon14.png'),
    },
    {
      id: '309',
      name: '行为指标管理',
      path: 'main.behaviorTagretList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '310',
      name: '操作日志',
      path: 'main.sysLogOperate',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '312',
      name: '储值卡充值',
      path: 'main.carStoreOrder',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '314',
    //   name: '园区鹰眼接口',
    //   path: 'main.videoMonitorInterface',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    {
      id: '315',
      name: '项目鹰眼接口',
      path: 'main.videoMonitorInterfaceNew',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '316',
      name: '任务模板管理',
      path: 'main.taskTemplateList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '317',
      name: '项目鹰眼监控',
      path: 'main.supplyVideoNew',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    // {
    //   id: '318',
    //   name: '重点工作管理',
    //   path: 'main.mainWorkList',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '319',
    //   name: '车辆管理管控',
    //   path: 'main.carUserList1',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '322',
    //   name: '审批列表',
    //   path: 'main.FromsApp',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '323',
    //   name: '待我处理',
    //   path: 'main.UnFinished',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '324',
    //   name: '已处理的',
    //   path: 'main.Finished',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '325',
    //   name: '我发起的',
    //   path: 'main.MySubmit',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '326',
    //   name: '抄送我的',
    //   path: 'main.CcMe',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '327',
    //   name: '数据管理',
    //   path: 'main.ProcessInstanceManage',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '328',
    //   name: '流程管理',
    //   path: 'main.FormsPanel',
    //   url_green: require('../../assets/imgs/wyglfw1.png'),
    //   url_pink: require('../../assets/imgs/wyglfw2.png'),
    //   url_bluegreen: require('../../assets/imgs/wyglfw3.png'),
    // },
    // {
    //   id: '35',
    //   name: '业主导入',
    //   path: 'main.import',
    //   url_green: require('../../assets/imgs/wygl1.png'),
    //   url_pink: require('../../assets/imgs/wygl2.png'),
    //   url_bluegreen: require('../../assets/imgs/wygl3.png'),
    // },
    {
      id: '333',
      name: '固定车出入记录',
      path: 'main.carInOutFixList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '335',
      name: '原始住户修改审批',
      path: 'main.basicInfoApproval',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '342',
      name: '商户管理',
      path: 'main.yhStoreManageList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
    {
      id: '343',
      name: '楼层管理',
      path: 'main.yhHouseManageList',
      url_green: require('../../assets/imgs/staticIcon.png'),
      url_pink: require('../../assets/imgs/staticIcon.png'),
      url_bluegreen: require('../../assets/imgs/staticIcon.png'),
    },
  ],
  // 菜单icon数组
  menu: [{
      name: 16,
      url: 'iconyezhuAPPfuwu'
    },
    {
      name: 10,
      url: 'icongongsiguanli'
    },
    {
      name: 13,
      url: 'iconqita'
    },
    {
      name: 12,
      url: 'iconshangpinguanli'
    },
    {
      name: 6,
      url: 'iconxiaoqufuwu'
    },
    {
      name: 9,
      url: 'iconxiaoquguanli'
    },
    {
      name: 11,
      url: 'iconguanggaoguanli'
    },
    {
      name: 14,
      url: 'iconwuyeguanli'
    },
    {
      name: 1,
      url: 'iconxitongguanli'
    },
    {
      name: 15,
      url: 'iconxiaoqufuwu'
    },
    {
      name: 27,
      url: 'icongongzuorenwu'
    },
    {
      name: 8,
      url: 'iconbaoshimoban'
    },
    {
      name: 18,
      url: 'iconzhinengxungeng'
    },
    {
      name: 19,
      url: 'iconwuyeshujufuwu'
    },
    {
      name: 17,
      url: 'iconwuyeguanlifuwu'
    },
    {
      name: 20,
      url: 'iconzulinzhongxin'
    },
    {
      name: 30,
      url: 'iconshequfuwuzhan'
    },
    {
      name: 31,
      url: 'icontingchechang1'
    },
    {
      name: 32,
      url: 'iconpingtai_kaoshi'
    },
    {
      name: 33,
      url: 'iconshoufeiguanli'
    },
    {
      name: 35,
      url: 'iconshangpinguanli'
    },
    {
      name: 36,
      url: 'iconjiangshipinggu'
    },
    {
      name: 38,
      url: 'iconxinglangzhihuishequ'
    },
    {
      name: 39,
      url: 'iconrenlianshibie'
    },
    {
      name: 37,
      url: 'iconwanjiefuwu'
    },
    {
      name: 40,
      url: 'iconxiaoquguanli'
    },
    {
      name: 41,
      url: 'iconshequfuwuzhan'
    },
    {
      name: 42,
      url: 'iconxiangmuhuaxiang'
    },
    {
      name: 43,
      url: 'icondangjianfuwu'
    },
    {
      name: 44,
      url: 'icondiantiwulianwang'
    },
    {
      name: 45,
      url: 'iconwangluochuncu'
    },
    {
      name: 46,
      url: 'iconziyuandianwei'
    },
    {
      name: 47,
      url: 'iconjichushuju'
    },
    {
      name: 48,
      url: 'iconyingyanjiankong'
    },
    {
      name: 49,
      url: 'iconzhinengmenjin'
    },
    {
      name: 50,
      url: 'iconzhinengtikong'
    },
    {
      name: 51,
      url: 'iconrenyuanduibi'
    },
    {
      name: 52,
      url: 'iconrenyuanduibi'
    },
    {
      name: 53,
      url: 'iconxiaoquguanli'
    },
    {
      name: 54,
      url: 'iconwuyeguanlifuwu'
    },
  ],

  CODE0: '执行成功',
  CODE1: '未知错误',
  CODE2: '执行失败',
  CODE3: '接口调用失败（传入接口参数有错误）',
  CODE4: '小乐在忙，请稍后再试',
  CODE5: '接口调用失败（未授权）',
  CODE6: '接口调用失败（未登录）',
  CODE7: '该楼/单元/房间已有用户，请勿删除',
  CODE8: '重复数据',
  CODE9: '该分类下还有小分类，请勿删除',
  CODE10: '已有数据绑定此评价，请勿删除',
  CODE11: '已有数据绑定此评价，请勿修改评语',
  CODE22: '当前工单状态已改变，请重新进入',
  CODE23: '当前工单数据错误，请联系管理员',
  CODE24: '接单人不能为报单人',
  CODE25: '接单人信用积分不符合标准',
  CODE26: '该账号已离职,暂时无法登陆',
  CODE38: '该园区未设置稽查人员，暂不能创建稽查工单',
  CODE101: '用户名或密码错误',
  CODE102: '名字重复',
  CODE103: '该小区已有默认联系方式',
  CODE104: '该用户不存在',
  CODE105: '手机号重复',
  CODE106: '该离职人员下有未完成的工单，请先提供工单接收人在进行离职办理！',
  CODE201: '合同编号重复',

  /** *****************共通start********************/
  lab_index: '序号',
  lab_id: '序号',
  lab_Id: 'ID',
  lab_operation: '操作',
  btn_homePage: '首页',
  btn_previousPage: '上一页',
  btn_nextPage: '下一页',
  btn_lastPage: '末页',
  btn_rest: '清空',
  btn_backpage: '返回',
  btn_save: '保存',
  btn_saveAndSubmit: '保存并发布',
  btn_search: '查询',
  btn_detail: '详情',
  btn_delete: '删除',
  btn_modify: '修改',
  btn_cancel: '取消',
  btn_confirm: '确定',
  btn_upload: '上传',
  btn_selectfile: '选取文件',
  btn_uploadtoserver: '上传到服务器',
  lab_isdelete: '是否删除?',
  lab_prompt: '提示',
  lab_del_success: '删除成功!',
  lab_del_fail: '删除失败',
  lab_del_can: '已取消删除',
  lab_login_can: '已取消重新登录',
  lab_save_success: '保存成功',
  lab_save_complainCancel: '撤销成功',
  lab_modify_success: '修改成功',
  lab_saveAndSubmit_success: '保存并发布成功',
  lab_text: '请输入正文...',
  lab_sort: '排序',
  lab_editor_tip1: '当前已输入',
  lab_editor_tip2: '个字符, 您还可以输入',
  lab_editor_tip3: '个字符。',
  lab_editor_tips: '字数超出最大允许值，服务器可能拒绝保存！',
  lab_please_Input: '请输入',
  lab_please_Select: '请选择',
  lab_please_Upload: '请上传',
  lab_add_success: '添加成功',
  lab_inputpassword: '密码必须6-18位字母或数字',
  btn_add: '添加',
  lab_isYes: '是',
  lab_isNo: '否',
  lab_pleaseSeletcUploadDoc: '请选择上传文件',
  lab_textText: '试卷',
  lab_seeBlock: '看板',
  lab_help: '帮助',
  lab_message: '个人信息',
  lab_zhCn: '中英文',
  lab_exit: '退出',
  lab_userNameId: '用户：',
  lab_changeColor: '正在换肤，请稍等...',
  lab_pinkType: '粉色主题',
  lab_greenType: '绿色主题',
  lab_blueType: '蓝色主题',
  lab_closeNow: '关闭当前',
  lab_closeAll: '关闭所有',
  lab_ispay: '是否支付?',
  lab_pay_can: '已取消支付',
  lab_setBtn: '设置',
  lab_reset_success: '重置成功',
  btn_showAll: '显示全部',
  /** *****************共通end********************/
  /** *****************广告管理共通start********************/
  lab_AdverAdd: '添加广告',
  lab_AdverId: 'ID',
  lab_AdverSort: '排序',
  lab_AdverType: '广告类型',
  lab_AdverTitle: '广告标题',
  lab_AdverStatus: '广告状态',
  lab_AdverEndTime: '过期时间',
  lab_AdverBeginDate: '开始时间',
  lab_AdverEndDate: '结束时间',
  lab_AdverSelectBeginDate: '请选择开始时间',
  lab_AdverSelsetEndDate: '请选择结束时间',
  lab_AdverGoUrl: '跳转链接',
  lab_AdverGoUrl2: '跳转链接2',
  lab_AdverGoUrl3: '跳转链接3',
  lab_AdverWriteUrl: '请输入链接地址',
  lab_AdverPlat: '广告平台',
  lab_AdverSortText: '数字越大排序越靠前',
  lab_AdverPleaseSort: '请排序',
  lab_AdverPleaseWriteUrlName: '请填写位置名称',
  lab_AdverTimeTips: '开始时间不能大于结束时间',
  lab_Online: '服务连接超时，请检查你的网络连接',
  lab_BigLink: '链接地址最多512字符',
  lab_BigLink100: '链接地址最多100字符',
  lab_notOnload: '账号信息失效，请重新登陆',
  lab_openTenMax: '最多只能打开10个标签页，如要打开请先关闭',
  lab_noGarden: '该账号下无所属小区',
  lab_pleaseSelectLinkType: '请选择链接类型',
  lab_pleaseWriteInsideText: '请输入链接内容',
  lab_pleaseWriteOutText: '请输入链接内容',

  /** *****************广告管理共通end********************/
  /***************
    页面路径：	广告管理->众乐汇广告管理
    页面中文名称：众乐汇广告管理
    页面英文名称：AllRemittanceadvertisingManagementList
    ******************/
  lab_AllRemitTitle: '请输入广告标题',
  lab_AllRemitStatus: '0',
  lab_AllRemitType: '200',
  lab_AllRemitBack: '返回众乐汇广告管理',
  AllRemitSelect: {
    AllReStatus: [{
        value: 1,
        label: '使用中'
      },
      {
        value: 2,
        label: '已停用'
      }
    ],
    AllReType: [{
        value: 201,
        label: '众乐汇轮播图'
      },
      {
        value: 202,
        label: '众乐汇大图'
      },
      {
        value: 203,
        label: '众乐汇膏药图'
      },
      {
        value: 204,
        label: '众乐汇推荐位'
      }
    ],
    AllReStyle: [{
        value: 0,
        label: '公用'
      },
      {
        value: 1,
        label: 'APP'
      },
      {
        value: 2,
        label: '小程序'
      }
    ],
  },
  /***************
    页面路径：	广告管理->首页广告管理
    页面中文名称：首页广告管理
    页面英文名称：indexAdvertisingList
    ******************/
  lab_indexAdBack: '返回首页广告管理',
  lab_indexAdStatus: '0',
  lab_indexAdType: '0',
  indexAdSelect: {
    indexAdStatus: [{
        value: 1,
        label: '使用中'
      },
      {
        value: 2,
        label: '已停用'
      }
    ],
    indexAdType: [{
        value: 1,
        label: '首页轮播图'
      },
      {
        value: 401,
        label: '首页大图'
      },
      {
        value: 402,
        label: '首页膏药条'
      },
      {
        value: 403,
        label: '首页推荐位'
      },
      {
        value: 404,
        label: '横幅大图'
      },
      {
        value: 405,
        label: '特大图'
      },
      {
        value: 406,
        label: '膏药图(3图)'
      }
    ],
    indexAdStyle: [{
        value: '0',
        label: '公用'
      },
      {
        value: '1',
        label: 'APP'
      },
      {
        value: '3',
        label: '小程序'
      }
    ],
  },
  /***************
   页面路径：	广告管理->积分广告管理
   页面中文名称：积分广告管理
   页面英文名称：IntegralADList
   ******************/
  lab_IntegralBack: '返回积分广告管理',
  lab_IntegralStatus: '0',
  lab_IntegralType: '100',
  IntegralSelect: {
    IntegralStatus: [{
        value: 1,
        label: '使用中'
      },
      {
        value: 2,
        label: '已停用'
      }
    ],
    IntegralType: [{
        value: 101,
        label: '签到'
      },
      {
        value: 102,
        label: '发帖'
      },
      {
        value: 103,
        label: '购物'
      },
      {
        value: 104,
        label: '物业报事'
      },
      {
        value: 105,
        label: '添加成员'
      },
      {
        value: 106,
        label: '投诉'
      }
    ],
    IntegralStyle: [{
        value: 0,
        label: '公用'
      },
      {
        value: 1,
        label: 'APP'
      },
      {
        value: 3,
        label: '小程序'
      }
    ],
  },
  /***************
   页面路径：	广告管理->邻里帮广告管理
   页面中文名称：邻里邦广告管理
   页面英文名称：NeighborhoodStateAdvertisementList
   ******************/
  lab_NeighBack: '返回邻里帮广告管理',
  lab_NeighStatus: '0',
  lab_NeighType: '300',
  NeighSelect: {
    NeighStatus: [{
        value: 1,
        label: '使用中'
      },
      {
        value: 2,
        label: '已停用'
      }
    ],
    NeighType: [{
      value: 304,
      label: '邻里帮轮播图'
    }],
    NeighlStyle: [{
        value: '0',
        label: '公用'
      },
      {
        value: '1',
        label: 'APP'
      },
      {
        value: '3',
        label: '小程序'
      }
    ],
  },
  /***************
   页面路径：	广告管理->邻里帮广告管理
   页面中文名称：邻里邦广告管理
   页面英文名称：NeighborhoodStateAdvertisementList
   ******************/
  lab_OwnerBack: '返回业主App广告管理',
  lab_OwnerVillageall: '所属小区',
  lab_OwnerFl: '分类',
  lab_OwnerName: '名称',
  lab_OwnerWriteName: '请输入名称',
  lab_OwnerBeginDate: '开始时间',
  lab_OwnerEndDate: '结束时间',
  lab_OwnerSort: '排序',
  lab_OwnerAround: '内链/外链',
  lab_OwnerInner: '内链',
  lab_OwnerWnner: '外链',
  lab_OwnerWnnerUrl: '外部链接url',
  lab_OwnerWnnerUrlTips: '请输入外部链接地址',
  /***************
   页面路径：	小区服务->报表下载
   页面中文名称：报表下载
   页面英文名称：reportManageList
   ******************/
  reportExportPro: '导出项目',
  reportSelectExportPro: '请选择导出项目',
  reportScreenDate: '时间筛选',
  reportBeginDate: '开始日期',
  reportEndDate: '结束日期',
  reportGo: '至',
  reportExportResult: '导出结果',
  reportVillage: '小区',
  reportPleaseSelectVillage: '请选择小区',
  reportPleaseSelectPro: '请选择导出项目',
  reportPleaseSelectDate: '请选择日期',
  reportDateTips: '相隔天数不能大于31天',
  reportExportProList: {
    ExportProList: [{
        id: 1,
        label: '报事统计'
      },
      {
        id: 2,
        label: '品质运营统计'
      },
      {
        id: 3,
        label: '品质运营统计-满意度'
      },
      {
        id: 4,
        label: 'APP绑定量统计'
      },
      {
        id: 5,
        label: '服务建议统计'
      },
      {
        id: 6,
        label: '工程人员报事接单统计'
      },
      {
        id: 7,
        label: '管家区域绩效统计'
      },
      {
        id: 8,
        label: '表扬/投诉统计'
      }
    ],
  },
  /***************
   页面路径：	物业管理服务->资源台账
   页面中文名称：资源台账新增
   页面英文名称：resourceLedgerAdd
   ******************/
  resourBack: '返回资源台账列表',
  resourProName: '项目名称',
  resourWriteProName: '请输入项目名称',
  resourProNum: '项目编号',
  resourWriteProNum: '请输入项目编号',
  resourPointName: '点位名称',
  resourWritePointName: '请输入点位名称',
  resourPointNum: '点位编号',
  resourWritePointNum: '请输入点位编号',
  resourPointAttr: '点位属性',
  resourWritePointAttr: '请选择点位属性',
  resourOneClassify: '一级资源分类',
  resourWriteOneClassify: '请选择一级资源分类',
  resourTwoClassify: '二级资源分类',
  resourWriteTwoClassify: '请选择二级资源分类',
  resourBuild: '楼栋',
  resourWriteBuild: '请输入楼栋名称',
  resourUnit: '单元',
  resourWriteUnit: '请输入单元名称',
  resourAdress: '位置',
  resourWriteAdress: '请输入位置',
  resourStatus: '状态',
  resourWriteStatus: '请选择状态',
  resourRemark: '备注',
  resourWriteRemark: '请输入备注',
  resourAddSuccess: '添加成功',
  resourAddLose: '添加失败',
  resourEditSuccess: '修改成功',
  resourEditLose: '修改失败',
  /***************
  页面路径：corporationManagement->userStrators->useristratorsList
  页面中文名称：部门列表
  页面英文名称：useristratorsList
  ******************/
  lab_deptName: '部门名称',
  lab_chooseGarden: '请选择小区',
  btn_addUseristrators: '添加本级新部门',
  lab_seeUser: '查看下级部门',
  lab_addUser: '添加下级部门',
  lab_inputDeptName: '请输入部门名称',
  lab_inputDeptNameTen: '部门名称最多10个字符',
  lab_depeIsEnd: '请勾选是否有下级部门',

  /***************
  页面路径：	corporationManagement->userStrators->addUserStratorsList
  页面中文名称：	添加部门列表
  页面英文名称：	addUserStratorsList
  ******************/
  lab_isNew: '有无下级部门',
  lab_have: '有',
  lab_notHave: '无',
  key_deptName: '部门名称',
  key_adddeptName: '添加部门',
  key_editdeptName: '修改部门',
  btn_returnUseristratorsList: '返回上级部门列表',

  /***************
  页面路径：	other->appVersionManagement->APPVersion
  页面中文名称：	APP版本管理
  页面英文名称：	APPVersion
  ******************/
  lab_uri: '下载地址',
  lab_appId: 'APP类型',
  lab_appAreaValue: 'APP平台',
  lab_upgradeLevel: '更新级别',
  lab_versionName: '版本友好显示名字',
  btn_AddApp: '添加APP版本',
  lab_user: '业主端',
  lab_VIPuser: '物业端',
  lab_noUpdate: '没有更新',
  lab_normalUpdate: '普通更新',
  lab_recommendUpdate: '推荐更新',
  lab_mustUpdate: '强制更新',
  lab_inputpositiveInteger: '请输入8位整数',
  lab_inputAPPVersionCodeEight: 'APP版本代码最多8位',
  btn_AddUniapp: '添加UniApp版本',
  /***************
  页面路径：	other->appVersionManagement->APPVersion
  页面中文名称：	添加APP版本
  页面英文名称：	addAppVersion
  ******************/
  lab_title: '升级标题',
  lab_content: '升级内容',
  lab_mobile: '上传文件',
  lab_versionCode: 'APP版本代码',
  key_uri: '下载地址',
  key_versionCode: 'APP版本代码',
  key_title: '升级标题',
  key_content: '升级内容',
  key_versionName: '版本友好显示名字',
  btn_returnApp: '返回APP版本管理',
  btn_backApp: '返回APP版本管理',
  text_up: '只能上传jpg/png文件，且不超过500kb',
  picture_tips: '请上传jpg/jpeg/png文件',
  picture_apktips: '请上传jpg/jpeg/png/apk文件',
  picture_wgttips: '请上传wgt文件',
  picture_tip_size: '请上传jpg/jpeg/png文件，且不超过500kb',
  video_tips: '请上传mp4文件',
  up_file: '点击上传',
  drag_file: '将文件拖到此处，或',
  key_up_file: '请选择上传文件',
  key_downurl: '请输入下载地址',
  key_appversion: '请输入APP版本代码',
  key_versionname: '请输入版本友好显示名字',
  key_versionNameIsTen: '版本友好显示名字最多10位',
  key_uptitle: '请输入升级标题',
  key_upcontent: '请输入升级内容',
  key_apptype: '请选择APP类型',
  key_appOrderBy: '请输入数字',
  key_appplatform: '请选择APP平台',
  key_appupdate: '请选择更新级别',
  btn_backUniapp: '返回UniApp版本管理',
  lab_uniappVersionCode: 'UniApp版本代码',
  key_uniappVersionCode: '请输入UniApp版本代码',
  lab_resourceId: '资源ID',
  key_resourceId: '请输入资源ID',
  appVersionManagement: {
    appType: [{
        label: 'APP类型 ',
        value: '0'
      },
      {
        label: '业主端',
        value: '1'
      },
      {
        label: '物业端',
        value: '2'
      }
    ],
    appUpdate: [{
        label: '没有更新 ',
        value: '0'
      },
      {
        label: '普通更新',
        value: '1'
      },
      {
        label: '推荐更新',
        value: '2'
      },
      {
        label: '强制更新',
        value: '3'
      }
    ],
    appArea: [{
        label: 'APP平台 ',
        value: '0'
      },
      {
        label: 'android',
        value: '1'
      },
      {
        label: 'ios',
        value: '2'
      }
    ]
  },
  /***************
  页面路径：	other->linkManagement->linkManagementList
  页面中文名称：	链接管理
  页面英文名称：	linkManagementList
  ******************/
  lab_addLink: '添加链接',
  lab_mainQuestion: '主题',
  lab_link: '链接',
  lab_linktitle: '标题',
  btn_backlink: '返回链接管理',
  key_linktitle: '请输入标题',
  lab_linkcontent: '图文内容',
  key_linkcontent: '请输入图文内容',

  /***************
  页面路径：	other->activityManagement->activityManagementList
  页面中文名称：	活动管理
  页面英文名称：	activityManagementList
  ******************/
  lab_activityName: '活动名称',
  btn_AddActivity: '添加活动',
  btn_Search: '查找',

  /***************
  页面路径：	other->activityManagement->activityManagementList
  页面中文名称：	添加活动
  页面英文名称：	addActivityManagement
  ******************/

  btn_backActivity: '返回活动管理',
  lab_garden: '所属小区',
  lab_beginTime: '活动时间',
  lab_endTime: '结束时间',
  lab_place: '活动地点',
  lab_goods: '选择商品',
  lab_telephone: '联系电话',
  lab_image: '上传图片',
  lab_image2: '上传图片2',
  lab_image3: '上传图片3',
  lab_contentNotice: '通知正文',
  lab_totalNum: '总人数上限',
  lab_eachNum: '每家人数上限',
  lab_cost: '费用',
  lab_closeTime: '报名截止日期',
  lab_orderBy: '排序',
  lab_homeShow: '首页显示',
  key_name: '请输入活动名称',
  key_place: '请输入活动地点',
  lab_InputcontentNotice: '请输入通知正文',
  key_eachNum: '请输入活动每家人数上限',
  key_cost: '请输入活动费用',
  key_totalNum: '请输入活动总人数上限',
  key_tekephone: '请输入活动联系电话',
  lab_isRelatedVote: '是否关联投票',
  lab_choiceVote: '选择投票',

  /***************
  页面路径：	other->activityManagement->seeActivityManagement
  页面中文名称：	活动详情
  页面英文名称：	seeActivityManagement
  ******************/
  lab_username: '用户名',
  lab_phone: '手机',
  lab_buildingnum: '楼号',
  lab_unitnum: '单元号',
  lab_roomnum: '房间号',
  lab_identitynum: '身份',
  lab_isOwner: '业主',
  lab_isFamilyMembers: '家属',
  lab_isTenant: '租客',

  /***************
  页面路径：	other->voteManages->voteManager
  页面中文名称：	投票管理
  页面英文名称：	voteManager
  ******************/
  lab_voteContent: '投票标题',
  lab_voteType: '单/多选',
  btn_addVote: '添加投票',
  btn_selVote: '查询',
  radio_voteOne: '单选',
  radio_voteMore: '多选',
  lab_option: '选项',
  lab_optionContent: '选项内容',
  lab_inputOptionContent: '请输入选项内容',
  lab_voteIsDelete: '是否删除？',
  lab_chanceVote: '选择一个投票',

  /***************
  页面路径：	other->redZoneManages->redZoneList
  页面中文名称：	红色专区
  页面英文名称：	redZoneList
  ******************/
  lab_redZoneTitle: '红色专区标题',
  lab_returnRedZoneList: '返回列表',
  lab_inputRedZoneContent: '请输入正文',
  lab_redZonePicLink: '图片链接',
  lab_redZonePleaseChance: '请选择',

  /***************
  页面路径：	other->borrowingManages->borrowingManager
  页面中文名称：	物品管理
  页面英文名称：	borrowingManager
  ******************/
  lab_borrowingManager: '物品管理',
  btn_addBorrowing: '添加物品',
  lab_editBorrowing: '修改物品',
  lab_borrowingName: '物品名称',
  btn_borrowingRecord: '借用记录',

  /***************
  页面路径：	other->borrowingManages->borrowingRecordList
  页面中文名称：	物品借用
  页面英文名称：	borrowingManager
  ******************/
  lab_borrowingRecord: '物品借用记录',
  lab_userNickName: '借用人昵称',
  lab_borrowingUserName: '借用人账号',
  lab_borrowingInfo: '借用备注',
  lab_returnInfo: '归还备注',
  lab_borrowingCreateTime: '借用时间',
  lab_planReturnTime: '计划归还时间',
  lab_returnTime: '归还时间',
  lab_borrowingState: '状态',

  /***************
  页面路径：	other->useSensation->useSensationList
  页面中文名称：	用后感
  页面英文名称：	useSensationList
  ******************/
  lab_contact: '电话',
  lab_useContent: '内容',

  /***************
  页面路径：	other->projectCalendar->projectCalendarList
  页面中文名称：	项目日历
  页面英文名称：	projectCalendarList
  ******************/
  btn_find: '查找',

  /***************
  页面路径：	other->machineroomManagement->machineroom
  页面中文名称：	机房设备管理
  页面英文名称：	machineroom
  ******************/
  lab_machineRoomName: '机房名称',
  lab_inputMachineRoomName: '请输入机房名称',
  lab_inputMachineRoomNameIs20: '机房名称最多20个字符',
  lab_inputDeviceName: '请输入机房绑定套件设备',
  lab_inputDeviceNameIs20: '机房绑定套件名称最多20个字符',
  lab_inputDutyPersonName: '请输入责任人名称',
  lab_inputDutyPersonNameIs20: '责任人名称最多20个字符',
  lab_inputDutyPersonPhone: '请输入责任人电话',
  lab_inputDutyPersonPhoneIsTrue: '请正确输入电话号码',
  lab_deviceName: '机房绑定套件设备',
  lab_dutyPersonName: '负责人名称',
  lab_dutyPersonPhone: '负责人电话',
  lab_addMachineRoom: '添加机房设备',
  lab_machineRoomTS: '调试状态',
  lab_machineRoomZC: '正常状态',
  lab_editMachineRoom: '修改机房设备',
  btn_lookfor: '查看',

  /***************
  页面路径：	other->machineroomManagement->addMachineroom
  页面中文名称：	添加机房设备
  页面英文名称：	addMachineroom
  ******************/
  lab_machineGarden: '所属小区',
  lab_state: '设备状态',
  btn_ReturnMachineroom: '返回机房设备管理',

  /***************
  页面路径：	other->labelManagement->label
  页面中文名称：	标签管理
  页面英文名称：	labellabel
  ******************/
  lab_labelName: '标签名称',
  lab_labelNameIs10: '标签名称最多10个字符',
  lab_inputLabel: '请填写标签名称',
  lab_createLabelTime: '创建日期',
  btn_AddLabel: '添加标签',
  lab_editLabel: '修改标签',

  /***************
  页面路径：	other->labelManagement->addLabel
  页面中文名称：	添加标签
  页面英文名称：	addLabel
  ******************/
  btn_ReturnLabel: '返回标签管理',

  /***************
  页面路径：	业主APP服务->发帖审核
  页面中文名称：	发帖审核
  页面英文名称：	postAuditList
  ******************/
  lab_village: '小区',
  lab_poster: '发帖人',
  lab_postingtime: '发布时间',
  lab_postingusername: '发帖用户：',
  lab_postingtimes: '发帖时间：',
  lab_postingdetail: '帖子详情：',
  lab_postingtelephone: '联系电话：',
  lab_postingtype: '帖子类型：',
  lab_posting: '发帖审核：',
  villageall: '全部小区',
  postclassification: '帖子分类',
  auditstatus: '审核状态',
  adsKey: '请输入发帖人搜索',
  modifyposting: '修改发帖审核',
  POSTAUDIT: {
    STATUEDETAIL: [{
        value: '1',
        label: '未审核'
      },
      {
        value: '2',
        label: '已审核通过'
      },
      {
        value: '3',
        label: '未审核通过'
      }
    ],
  },

  /***************
  页面路径：	其他->标语管理
  页面中文名称：	标语管理
  页面英文名称：	posterList
  ******************/
  addposterBtn: '添加标语',
  lab_sloganclassification: '标语分类',
  lab_slogancontent: '标语内容',
  lab_jumplink: '跳转链接',
  lab_Sloganvalidityperiod: '标语有效期',
  lab_sloganclassifications: '标语分类',
  lab_slogancontents: '标语内容',
  lab_jumplinks: '跳转链接',
  lab_uptimes: '上线时间',
  lab_downtimes: '下线时间',
  selecttimes: '选择日期',
  modifyposter: '修改标语',
  postertypes: '请输入标语分类',
  postercontent: '标语内容',
  posterlink: '跳转链接',
  posteruptime: '请输入上线时间',
  posterdowntime: '请输入下线时间',
  posterservice: '服务建议',
  // 标语管理
  POSTER: {
    SERVICE: [{
      value: 1,
      label: '服务建议'
    }],
  },

  /***************
  页面路径：	其他->供应商管理
  页面中文名称：	供应商管理
  页面英文名称：	supplierList
  ******************/
  addsupplierBtn: '添加供应商',
  lab_cooperation: '合作期限',
  lab_remark: '备注',
  lab_suppliername: '供应商名称',
  suppliername: '请输入供应商名称',
  supplierphone: '请输入供应商联系电话（区号-固话号码）',
  suppliertime: '请输入合作期限（长期/短期）',
  modifysupplier: '修改供应商',
  supplierremark: '请输入备注',

  /***************
  页面路径：	其他->类型设置
  页面中文名称：	类型设置
  页面英文名称：	typeList
  ******************/
  addtypeBtn: '添加类型',
  lab_typename: '类型名称',
  lab_Goformorestyle: '巡更点样式',
  lab_Signinway: '签到方式',
  lab_styles: '样式',
  lab_typenames: '类型名称',
  lab_Signinways: '签到方式',
  modifytype: '修改类型',
  typenames: '请输入类型名称',
  TYPE: {
    SIGN: [{
        value: 1,
        label: '二维码签到'
      },
      {
        value: 2,
        label: '拍照签到'
      }
    ],
  },

  /***************
  页面路径：	其他->人员分配
  页面中文名称：	人员分配
  页面英文名称：	personnelList
  ******************/
  addpersonnelBtn: '添加分组',
  lab_groupname: '分组名称',
  lab_groupmembers: '组成员',
  lab_groupnames: '分组名称',
  lab_groupmemberss: '组成员',
  modifygroups: '修改分组',
  addgroups: '添加分组',
  groupnamerule: '请输入分组名称',
  grouppeoplerule: '请选择组成员',
  lab_groupnubmax: '组成员最多能添加7人',
  /***************
  页面路径：	公司管理->管理员列表
  页面中文名称：	管理员列表
  页面英文名称：	administratorsList
  ******************/
  accountOrname: '请输入账号或姓名搜索',
  addadministratorsBtn: '添加管理员',
  lab_account: '账号',
  lab_workstatus: '工作状态',
  lab_userid: '员工编号',

  /***************
  页面路径：	公司管理->管理员详情
  页面中文名称：	管理员详情
  页面英文名称：	addAdminStrators
  ******************/
  btn_backAdminStrators: '返回管理员列表',
  lab_Adminphone: '手机号',
  pla_Adminphone: '请输入手机号',
  lab_Adminpassw: '密码',
  pla_Adminpassw: '请输入密码',
  lab_Adminrespassw: '再次输入密码',
  pla_Adminrespassw: '请再次输入密码',
  pla_twoAdminrespassw: '两次输入密码不一致!',
  lab_Adminnickname: '姓名',
  pla_Adminnickname: '请输入姓名',
  lab_Distributionauthority: '派单权限',
  pla_Distributionauthority: '请选择派单权限',
  lab_Authoritytocomplain: '表扬/投诉权限',
  pla_Authoritytocomplain: '请选择表扬/投诉权限',
  lab_Closetheaccess: '关闭报事工单权限',
  lab_SetUp: '优良工单设置',
  pla_Closetheaccess: '请选择关闭报事工单权限',
  pla_SetUp: '请选择优良工单设置',
  lab_Adminrole: '人员角色',
  pla_Adminrole: '请选择人员角色',
  lab_Admingarden: '所属小区',
  pla_Admingarden: '请选择所属小区',
  lab_staffDoorAuthority: '门禁权限',
  lab_targetValue: '员工目标值',
  lab_targetFeeValue: '员工收费目标值',
  lab_targetFeeGardenValue: '本期收费目标值',
  lab_targetFeeGardenArrearsValue: '拖欠收费目标值',
  lab_changeYear: '请选择目标年份',
  lab_targetMonth1: '请输入1月目标值',
  lab_targetMonth2: '请输入2月目标值',
  lab_targetMonth3: '请输入3月目标值',
  lab_targetMonth4: '请输入4月目标值',
  lab_targetMonth5: '请输入5月目标值',
  lab_targetMonth6: '请输入6月目标值',
  lab_targetMonth7: '请输入7月目标值',
  lab_targetMonth8: '请输入8月目标值',
  lab_targetMonth9: '请输入9月目标值',
  lab_targetMonth10: '请输入10月目标值',
  lab_targetMonth11: '请输入11月目标值',
  lab_targetMonth12: '请输入12月目标值',
  lab_isFeeManager: '是否为财务管理员',
  lab_isExamManager: '是否为考试管理员',
  lab_resetPassword: '重置密码',
  AdminStrators: {
    isDispatchlist: [{
        id: 0,
        name: '不可以派单'
      },
      {
        id: 1,
        name: '可以派单'
      }
    ],
    isComplaintAndCommendationlist: [{
        id: 0,
        name: '不可以表扬/投诉'
      },
      {
        id: 1,
        name: '可以表扬/投诉'
      }
    ],
    isCloselist: [{
        id: 0,
        name: '不可以关闭'
      },
      {
        id: 1,
        name: '可以关闭'
      }
    ],
    isSetUpList: [{
        id: 0,
        name: '不显示'
      },
      {
        id: 1,
        name: '显示'
      }
    ],
    isFeeManagerList: [{
        id: 0,
        name: '否'
      },
      {
        id: 1,
        name: '是'
      }
    ],
    isExamManagerList: [{
        id: 0,
        name: '否'
      },
      {
        id: 1,
        name: '是'
      }
    ],
  },

  /***************
  页面路径：	小区管理->物业信用积分体系
  页面中文名称：	物业信用积分体系
  页面英文名称：	propertyCreditScoreSys
  ******************/
  lab_propertyCreditScoreSystem: '物业信用积分',
  lab_name: '姓名',
  lab_creditInregral: '信用积分',
  lab_authority: '接单权限',
  lab_normal: '正常接单',
  lab_forbid: '禁止接单',
  lab_levelList: '评价等级列表',
  lab_rating: '评价等级',
  lab_praise: '好评',
  lab_average: '中评',
  lab_bad: '差评',
  lab_currentPage: '当前',
  pla_accountorname: '账号或姓名',
  pla_maxscore: '最大积分',
  pla_minscore: '最小积分',
  pla_orderpermission: '接单权限',
  pla_normal: '正常接单',
  pla_forbid: '禁止接单',
  btn_look: '查看评价评语',
  btn_returnPropertyCreditScoreSys: '返回物业信用积分体系',
  btn_returnlab_levelList: '返回评价等级',
  btn_addpraise: '添加好评',
  btn_addaverage: '添加中评',
  btn_addbed: '添加差评',
  btn_changepraise: '修改好评',
  btn_changeaverage: '修改中评',
  btn_changebed: '修改差评',
  display: '是否显示',
  diaplay_true: '显示',
  display_false: '不显示',
  reviews: '评价评语',
  pleaseEnterContent: '请输入内容',
  evaluationDisplay: '评价显示内容',
  yes: '是',
  no: '否',
  lab_sel_display: '请选择是否显示',
  lab_plea_review: '请输入评价评语',
  PROPERTYCREDITSCORESYS: {
    TYPE: [{
        value: '0',
        label: '接单权限'
      },
      {
        value: '1',
        label: '正常接单'
      },
      {
        value: '2',
        label: '禁止接单'
      }
    ],
    DETAILS: [{
      id: '1',
      level: '好评'
    }, {
      id: '2',
      level: '中评'
    }, {
      id: '3',
      level: '差评'
    }],
  },
  /***************
  页面路径：	小区服务->业主通知
  页面中文名称：	业主通知
  页面英文名称：	proprietorNotification
  ******************/
  btn_addNotif: '添加通知',
  btn_returnNotif: '返回业主通知',
  lab_sendType: '发送类型',
  lab_titleNotif: '通知主题',
  lab_createTime: '发布时间',
  lab_proprietor: '业主端',
  lab_property: '物业端',
  lab_proprietorAndProperty: '全部',
  lab_notification: '通知正文',
  lab_sendRange: '发送范围',
  lab_selectHouse: '请选择楼号',
  lab_selectSendType: '请选择发送类型',
  lab_selectUnit: '请选择单元号',
  lab_selectRoom: '请选择房间号',
  lab_classify: '分类',
  lab_selectClassify: '请选择分类',
  lab_displayDeadline: '显示期限',
  lab_endToDate: '截止至过期时间',
  lab_neverOutDate: '永不过期',
  lab_deadline: '过期时间',
  lab_selectDeadline: '请选择过期时间',
  lab_fillinNotification: '通知主题，15字以内',
  lab_selectTitleNotif: '请输入通知主题',
  lab_selectDisplayDeadline: '请选择显示期限',
  lab_selectNotification: '请输入通知正文',
  ProprietorNotificationEdit_sendTypes: [{
    value: 1,
    label: '业主端'
  }, {
    value: 2,
    label: '物业端'
  }, {
    value: 3,
    label: '全部'
  }],
  ProprietorNotificationEdit_classifys: [{
    value: 1,
    label: '邻里活动'
  }, {
    value: 2,
    label: '社区通知'
  }, {
    value: 3,
    label: '业主福利'
  }, {
    value: 4,
    label: '温馨提示'
  }],

  /***************
  页面路径：	小区服务->集团网站维护
  页面中文名称：	集团网站维护
  页面英文名称：	groupWebsite
  ******************/
  btn_addGroupNews: '添加新闻',
  btn_returnGroupNews: '返回新闻列表',
  lab_titleGroupNews: '新闻标题',
  lab_contentGroupNews: '新闻正文',
  lab_fillinGroupNewsication: '新闻标题，50字以内',
  lab_selectTitleGroupNews: '请输入新闻标题',
  lab_selectGroupNewscation: '请输入新闻正文',
  lab_selectImgGroupNews: '请上传新闻图片',
  /***************
  页面路径：	小区服务->业主私信
  页面中文名称：	业主私信
  页面英文名称：	proprietorPrivateletter
  ******************/
  btn_send: '发送',
  btn_sendToUser: '给业主发私信',
  btn_sendToBuilding: '给一栋楼用户发私信',
  btn_sendToAll: '给全部用户发私信',
  lab_titleAnd: '题目',
  lab_contentAnd: '内容',
  lab_buildNum: '楼号',
  lab_userTel: '业主电话',
  lab_pleaseEnterTitle: '请输入题目',
  lab_pleaseEnterContent: '请输入内容',
  lab_pleaseEnterTel: '请输入注册众乐家APP的业主电话',
  lab_pleasebuildNum: '请选择楼号',
  lab_pleaseInput: '该内容不能为空',

  /***************
  页面路径：	其他->异常记录
  页面中文名称：	异常记录
  页面英文名称：	patrolException
  ******************/
  lab_lineName: '线路名称',
  lab_abnormalPosition: '异常位置',
  lab_abnormalDescription: '异常说明',
  lab_picture: '照片',
  lab_feedbackPerson: '反馈人',
  lab_feedbackTime: '反馈时间',

  /***************
  页面路径：	业主APP服务->众邻观点
  页面中文名称：	众邻观点
  页面英文名称：	neighborView
  ******************/
  btn_addneighborView: '添加众邻观点',
  btn_returnNeighborView: '返回众邻观点',
  lab_redpoint: '红方观点',
  lab_bluepoint: '蓝方观点',
  lab_numberofresponses: '投票数量',
  lab_percentageofvotes: '投票比例（红:蓝）',
  lab_nickName: '用户昵称',
  lab_userName: '手机',
  lab_redBlue: '支持方',
  lab_red: '红方',
  lab_blue: '蓝方',
  lab_info: '支持内容',
  lab_community: '所属小区',
  lab_selectCommunity: '请选择小区',
  lab_infos: '内容',
  lab_deadlineTime: '截止时间',
  lab_photograph: '图片',
  lab_uploadPhotograph: '上传图片',
  lab_uploadWarning: '选择的上传文件个数超出文件的最大限制个数 1！',
  lab_uploadWarning9: '选择的上传文件个数超出文件的最大限制个数 9！',
  lab_uploadWarningx: '选择的上传文件个数超出文件的最大限制个数',
  lab_selectDeadlineTime: '请选择截止时间',
  lab_pleaseContent: '请输入内容',
  lab_pleaseRed: '请输入红方观点',
  lab_pleaseBlue: '请输入蓝方观点',
  lab_pleaseUploadPhotograph: '请上传图片',
  lab_allVillage: '全部小区',
  lab_selectOneVillage: '请选择至少选择一个小区！',

  /***************
  页面路径：小区管理->居家服务劳动所得	
  页面中文名称：居家服务劳动所得	
  页面英文名称：incomeHomeServiceLabor	
  ******************/
  lab_staffId: '工号',
  lab_waitLabor: '待发放金额',
  lab_sumLabor: '所有劳务所得',
  btn_lookfordetail: '查看详情',
  btn_retIncomeList: '返回居家服务提成列表',
  lab_workNum: '工单单号',
  lab_workAmont: '工单金额',
  lab_workCommission: '工单提成',

  /***************
  页面路径：	业主APP服务->周边服务
  页面中文名称：	周边服务
  页面英文名称：	peripheral
  ******************/
  btn_addPeripheral: '添加周边服务',
  btn_returnPeripheral: '返回周边服务列表',
  lab_serviceType: '服务类型',
  lab_recommendedStatus: '推荐状态',
  lab_preferentialStatus: '优惠状态',
  lab_inputNameOrTel: '输入名称或联系方式',
  lab_tel: '联系方式',
  lab_merchantName: '商家名称',
  lab_normalStatus: '正常',
  lab_recommended: '推荐',
  lab_preferential: '优惠',
  lab_marchantDetail: '服务商家详情',
  lab_marchantNames: '服务商家名称',
  lab_telephoneNum: '联系电话',
  lab_detailAdd: '详细地址',
  lab_alleyeAdd: '全景地址',
  lab_marchantLogo: '服务商家Logo',
  lab_plaMarchantDetail50: '请输入服务商家名称，50字以内',
  lab_plaMarchantName50: '请输入服务联系电话',
  lab_plaDetailAdd200: '请输入详细地址，200字以内',
  lab_plaAlleyeAdd: '请输入全景地址',
  lab_plaDetailAdd: '请输入详细地址',
  lab_plaMarchantNames: '请输入服务商家名称',
  lab_plaTelephoneNum: '请输入联系电话',
  lab_plaOrderby: '请选择排序',
  lab_plaServiceType: '请选择服务类型',
  lab_plaRecommendedStatus: '请选择推荐状态',
  lab_plaPreferentialStatus: '请选择优惠状态',
  lab_plaMarchantDetail: '请输入商家详情',
  lab_error: '服务商家名称重复',
  PeripheralEdit_recommends: [{
    value: 0,
    label: '正常'
  }, {
    value: 1,
    label: '推荐'
  }],
  PeripheralEdit_discounts: [{
    value: 0,
    label: '正常'
  }, {
    value: 1,
    label: '优惠'
  }],
  /***************
  页面路径：	小区管理->居家服务提成设置
  页面中文名称：	居家服务提成设置
  页面英文名称：	homeServiceCommission
  ******************/
  lab_catePerson: '人员类别',
  lab_minCreditScore: '最小信用积分',
  lab_Royalty_unit: '提成比例(单位%)',
  lab_modifyRules: '修改提成规则',
  lab_pleaseInputMinCreditScore: '请输入最小信用积分',
  lab_pleaseInputRoyalty: '请输入提成比例',
  INCOMEHONESERVICELABOR: {
    STAFFTYPE: [{
        value: '1',
        label: '工程人员'
      },
      {
        value: '2',
        label: '区域管家'
      },
      {
        value: '3',
        label: '项目工程负责人（班长或主管）'
      }
    ]
  },

  /***************
    页面路径：	小区管理->鹰眼接口管理
    页面中文名称：	园区鹰眼接口
    页面英文名称：eagleEyeList
    ******************/
  eagleEye: {
    add: '添加鹰眼接口',
    alter: '修改鹰眼接口',
    retEye: '返回鹰眼接口列表',
    housing: '小区',
    eagleLocation: '园区鹰眼位置',
    eagleUrl: '鹰眼接口连接',
    allHouse: '所有小区',
    whereAt: '所在小区:',
    hBuilding: '楼号:',
    cell: '单元:',
    whereName: '园区鹰眼位置:',
    fillWhereName: '请输入园区鹰眼位置',
    fillWhereUrl: '请输入鹰眼接口连接',
    whereUrl: '鹰眼接口连接:',
    chooseAt: '请选择小区',
    choosecell: '请选择单元',
    chooseBuilding: '请选择楼号',
    sureSave: '确定保存么?',
    sureChange: '确定修改么?',
    sureAdd: '确定添加么?',
    addSucceed: '添加成功',
    alterSucceed: '修改成功',
    subfail: '提交失败',
    videoMonitorTypeName: '鹰眼分类',
    choosevideoMonitorTypeName: '请选择鹰眼分类',
  },

  /***************
   页面路径：	小区管理->小区管理
   页面中文名称：小区管理
   页面英文名称：eagleEyeList
   ******************/
  housearea: {
    add: '添加小区',
    houseNames: '小区名称',
    houseName: '小区名称:',
    provinces: '省份',
    province: '省份:',
    citys: '城市',
    city: '城市:',
    rtnhouse: '返回小区管理',
    newName: '新小区的名称:',
    onlyopen: '是否仅有开门权限:',
    writeName: '请输入小区名称',
    isshow: '业主端是否显示:',
    owndo: '是否独立运营:',
    housecode: '小区编码:',
    carcode: '停车场编码:',
    choosep: '请选择省份',
    choosec: '请选择城市',
    normal: '正常',
    onlydoor: '仅有开门权限',
    show: '显示',
    notshow: '不显示',
    yes: '是',
    no: '否',
    gardenLogo: '小区LOGO',
    isLiftControl: '是否有一键乘梯功能',
    gardenLogoType: '小区LOGO类型',
    defaultLogo: '默认Logo',
    customLogo: '自定义Logo',
    noLogo: '无Logo'
  },

  /***************
    页面路径：	小区管理->小区管理
    页面中文名称：小区管理
    页面英文名称：eagleEyeList
    ******************/
  ownerApp: {
    subBtn: '提交',
    sloganName: '业主App广告名称',
    addSlogan: '添加业主App广告',
    eagleLocation: '园区鹰眼位置',
    eagleUrl: '鹰眼接口连接',
    allHouse: '所有小区',
    whereAt: '所在小区:',
    building: '楼号:',
    cell: '单元:',
    whereName: '位置名称:',
    whereUrl: '位置URL:',
    chooseAt: '请选择小区',
    chooseBuilding: '请选择楼号',
    insideText: '内部链接文本'
  },
  options: [{
      label: '开门广告',
      value: 1
    },
    {
      label: '启动页广告',
      value: 2
    },
    {
      label: '首页广告',
      value: 3
    }
  ],
  optionsSecCategory: [{
      label: '开门广告-上',
      value: 1
    },
    {
      label: '开门广告-中',
      value: 2
    },
    {
      label: '开门广告-下',
      value: 3
    }
  ],

  /***************
    页面路径：	小区管理->集团管理
    页面中文名称：集团管理
    页面英文名称：groupsManageList
    ******************/
  lab_groupsName: '集团名称',
  lab_addGroups: '添加集团',
  lab_editGroups: '修改集团',
  lab_configGroups: '配置',
  lab_configGarden: '配置小区',
  lab_deleteGroupRemind: '此操作将永久删除该条数据, 是否继续?',

  /***************
  页面路径：	小区信息服务->原始住户数据管理
  页面中文名称：	原始住户数据管理
  页面英文名称：	preHouseholdInfoManage
  ******************/
  btn_addPreHouseholdInfo: '添加原始数据',
  btn_excelDl: '表格下载',
  btn_downloadTemplate: '下载模板',
  btn_importExcel: '导入业主',
  btn_importTaskExcel: '导入电梯巡检任务',
  btn_createTask: '创建计划任务',
  btn_selectExcel: '选择文件',
  btn_returnPreHouseholdInfo: '返回原始数据管理',
  lab_preHouseholdName: '业主名',
  lab_preHouseholdPhone: '手机',
  lab_preHouseholdID: '身份证号',
  lab_preHouseholdArea: '建筑面积',
  lab_feeArea:'计费面积',
  lab_preHouseholdNameOrPhone: '业主姓名或手机号',
  lab_preHouseholdId: '序号',
  lab_phoneNum: '手机号码',
  lab_realName: '真实姓名',
  lab_theVillage: '所属小区',
  lab_theBuildingNum: '所属楼号',
  lab_theUnitNum: '所属单元号',
  lab_theRoomNum: '所属房间号',
  lab_theAddress: '详细地址',
  lab_theDeliveryTime: '交付时间',
  lab_selectPhoneNum: '请输入手机号码',
  lab_selectName: '请输入姓名',
  lab_selectID: '请输入身份证号',
  lab_selectVillage: '请选择小区',
  lab_selectBuildingNum: '请选择楼号',
  lab_selectUnitNum: '请选择单元号',
  lab_selectRoomNum: '请选择房间号',
  lab_selectAddress: '请输入地址',
  lab_selectArea: '请输入面积',
  lab_selectDeliveryTime: '请选择交付时间',
  lab_phoneNumIsNum: '手机号码只能输入数字',
  lab_buildingNum: '楼号',
  lab_unitNum: '单元号',
  lab_roomNum: '房间号',
  lab_isIllegality_ID: '身份证输入不合法',
  lab_phones: '备用电话',
  lab_selectPhones: '请输入备用电话',
  lab_fjType: '附件类型',
  lab_fjName: '附件名称',
  lab_indexFjType: '0',
  lab_transfer: '转让',
  lab_transferPlace: '转让车位',
  lab_carPlace: '车位',
  lab_describe: '描述',
  lab_operator: '操作人',
  fjTypes: [{
      value: 8,
      label: '入住文件'
    },
    {
      value: 9,
      label: '装修管理'
    },
    {
      value: 10,
      label: '车位管理'
    },
    {
      value: 11,
      label: '保险理赔'
    },
    {
      value: 12,
      label: '法律诉讼'
    },
    {
      value: 13,
      label: '二手房交易'
    },
    {
      value: 14,
      label: '返修管理'
    },
    {
      value: 7,
      label: '其它附件'
    }
  ],

  /***************
  页面路径：	物业管理->任务管理
  页面中文名称：	任务管理
  页面英文名称：	taskManageList
  ******************/
  btn_addTask: '添加任务',
  btn_returnTask: '返回任务管理',
  lab_myLaunch: '我发起的',
  lab_maintainOne: '请选择报事一级分类',
  lab_maintainTwo: '请选择报事二级分类',
  lab_maintainThree: '请选择报事三级分类',
  lab_maintainFour: '请选择报事四级分类',
  lab_maintainFive: '请选择报事五级分类',
  lab_states: '请选择状态',
  lab_gardenName: '小区名称',
  lab_compoundName: '名称',
  lab_typeName1: '一级分类',
  lab_typeName2: '二级分类',
  lab_typeName3: '三级分类',
  lab_typeName4: '四级分类',
  lab_typeName5: '五级分类',
  lab_taskContent: '内容',
  lab_isCreatePersonName: '创建人',
  lab_isDutyPersonName: '责任人',
  lab_isSelectCommunity: '请选择小区',
  lab_allCommunity: '全部小区',
  lab_taskName: '任务名称',
  lab_taskInspect: '是否稽查',
  lab_isInspectYes: '是',
  lab_isInspectNo: '否',
  lab_workDay: '工期（天）',
  lab_workCycle: '任务周期',
  lab_taskYear: '年',
  lab_taskMonth: '月',
  lab_taskWeek: '星期',
  lab_taskDay: '天',
  lab_taskHour: '时间',
  lab_taskMinute: '分钟',
  lab_taskTime: '计划开始/结束时间',
  lab_taskVillage: '小区/负责人',
  lab_taskStandard: '巡检标准',
  lab_addTaskStandard: '确定添加',
  lab_taskRoom: '房间号',
  lab_taskPerson: '负责人',
  lab_taskOperation: '操作',
  lab_taskDevice: '巡检设备',
  lab_taskRoute: '巡检路线',
  // start new By LiLiBin 2021/06/24 13:41
  lab_taskVenue: '资源点位',
  // end new By LiLiBin 2021/06/24 13:41
  lab_taskVillageList: '小区/负责人列表',
  lab_taskStandardList: '巡检标准列表',
  lab_houseUintRoomList: '楼号单元房间列表',
  lab_theHURList: '楼号/单元/房间',
  lab_taskDeviceList: '巡检设备列表',
  lab_taskStandardPreview: '巡检标准预览',
  lab_taskRouteList: '巡检路线列表',
  // start new By LiLiBin 2021/06/24 13:41
  lab_taskVenueList: '资源点位列表',
  // end new By LiLiBin 2021/06/24 13:41
  lab_taskRoutePreview: '巡检路线预览',
  lab_taskGarden: '所属小区',
  lab_taskStaff: '责任人',
  lab_taskFileUploadGarden: '上传园区资料附件',
  lab_taskFileUpload: '上传附件',
  lab_taskEditFileUpload: '附件',
  btn_taskEditFileUpload: '附件下载',
  lab_confirmPause: '是否停止该任务',
  lab_confirmPlay: '是否开启该任务',
  lab_successPause: '停止成功',
  lab_successPlay: '开启成功',
  lab_taskPlay: '启动',
  lab_taskPause: '停止',
  lab_taskAllCheck: '全选',
  lab_taskStandardDelete: '确定要删除吗',
  lab_taskTitlePoint: '点位图',
  lab_taskWarningCycle: '周或者日只能选择一种',
  lab_taskWarningCycle1: '请至少选择一个星期',
  lab_taskWarningCycle2: '请至少选择一个日期',
  lab_taskWarningHour: '请至少选择一个小时',
  lab_taskWarningMaintain: '请选择一级分类',
  lab_taskWarningStaff: '请至少选择一个负责人',
  lab_taskWarningStandardPreview: '请至少添加一条巡检标准',
  lab_taskWarningDelete: '确定要删除吗',
  pla_inputKeyword: '请输入名称',
  lab_selectStandardPreview: '请选择巡检标准',
  lab_deleteError: '删除失败，请刷新页面后，再次尝试删除',
  lab_pauseError: '停止失败，请刷新页面后，再次尝试停止',
  lab_playError: '启动失败，请刷新页面后，再次尝试启动',
  lab_editError: '保存失败，请重新编辑任务',
  lab_addError: '新增失败，请重新新增任务',
  lab_taskWarningtypeId3: '电梯保养请选择三级分类',
  lab_taskWarningisNeedSignin: '电梯保养请选择开启签到',
  TaskImportType: [{
      value: 0,
      label: '未导入'
    },
    {
      value: 1,
      label: '已导入'
    }
  ],
  TaskManageList_stateList: [{
    id: 1,
    name: '启动'
  }, {
    id: 0,
    name: '停止'
  }],
  EditTask_cycles: [{
    id: 1,
    name: '星期'
  }, {
    id: 2,
    name: '天'
  }],
  /***************
  页面路径：	小区信息服务->小区信息管理
  页面中文名称：	小区信息管理
  页面英文名称：	communityInfoManage
  ******************/
  btn_addHouseId: '添加楼号',
  btn_addUnitId: '添加单元号',
  btn_addRoomId: '添加房间号',
  btn_returnHomepageManage: '返回首页信息管理',
  btn_returnHouseManage: '返回楼房管理',
  lab_modifyHouseId: '修改楼号',
  lab_modifyUnitId: '修改单元号',
  lab_modifyRoomId: '修改房间号',
  lab_isHouseId: '楼号',
  lab_isUnitId: '单元号',
  lab_isRoomId: '房间号',
  lab_pleaseEnterCItext: '请输入内容',
  lab_housekeeper: '管家',
  lab_taskRoomInfo: '房屋信息',

  /***************
  页面路径：	报事模块->报事类型设置
  页面中文名称：	报事类型设置
  页面英文名称：	maintainTypeManage
  ******************/
  btn_addMaintianType1: '添加一级分类',
  btn_addMaintianType2: '添加二级分类',
  btn_addMaintianType3: '添加三级分类',
  btn_addMaintianType4: '添加四级分类',
  btn_addMaintianType5: '添加五级分类',
  btn_returnMaintainTypeManage: '返回报事分类管理',
  btn_returnMaintianType2: '返回二级分类管理',
  btn_returnMaintianType3: '返回三级分类管理',
  btn_returnMaintianType4: '返回四级分类管理',
  lab_onlyToProperty: '只有物业可见',
  lab_modifyMaintianType1: '修改一级分类',
  lab_modifyMaintianType2: '修改二级分类',
  lab_modifyMaintianType3: '修改三级分类',
  lab_modifyMaintianType4: '修改四级分类',
  lab_modifyMaintianType5: '修改五级分类',
  lab_maintianType1: '一级分类',
  lab_maintianType2: '二级分类',
  lab_maintianType3: '三级分类',
  lab_maintianType4: '四级分类',
  lab_maintianType5: '五级分类',
  lab_pleaseEnterMTtext: '请输入分类名称',
  lab_pleaseSeletcOnlyToProperty: '请选择是否仅物业可见',
  lab_default: '默认',

  /***************
  页面路径：	物业管理->合同分类
  页面中文名称：	报事类型设置
  页面英文名称：	maintainTypeManage
  ******************/
  btn_addContractType1: '添加一级分类',
  btn_addContractType2: '添加二级分类',
  btn_addContractType3: '添加三级分类',
  btn_returnContractTypeManage: '返回合同分类管理',
  btn_returnContractType2: '返回二级分类管理',
  lab_modifyContractType1: '修改一级分类',
  lab_modifyContractType2: '修改二级分类',
  lab_modifyContractType3: '修改三级分类',
  lab_contractType1: '一级分类',
  lab_contractType2: '二级分类',
  lab_contractType3: '三级分类',
  lab_pleaseEnterCTtext: '请输入合同分类名称',

  /***************
  页面路径：	物业管理->业主端Logo管理
  页面中文名称：	业主端Logo管理
  页面英文名称：	proprietorLogoManage
  ******************/
  lab_logo: 'Logo',
  lab_pleaseUploadLogo: '请上传Logo',

  /***************
  页面路径：	物业管理->人事信息
  页面中文名称：	人事信息
  页面英文名称：	personnelAllotment
  ******************/
  lab_isStaffId: '员工编号',
  lab_isDeptName: '部门',
  lab_isTitle: '职务',
  lab_isName: '姓名',
  lab_isMobile: '电话',
  lab_isHiredDate: '入职时间',
  lab_isBindId: '绑定状态',
  lab_isBindYES: '已绑定',
  lab_isBindNO: '未绑定',
  lab_isBindAPP: '绑定APP',
  lab_pleaseDeptName: '绑定APP',

  /***************
  页面路径：	系统管理->菜单管理
  页面中文名称：	菜单管理
  页面英文名称：	menuManagementList
  ******************/
  btn_addMenu1: '添加一级菜单',
  btn_addMenu2: '添加二级菜单',
  btn_deleteMenu: '删除当前菜单',
  lab_keyword: '关键字',
  lab_menuName: '菜单名称',
  lab_menuSource: '菜单来源',
  lab_menuCode: '菜单编码',
  lab_menuLink: '菜单链接',
  lab_menuCheckGrade: '查看范围',
  lab_selectMenuLevel1: '请选择一个一级菜单！',
  lab_select1Menu: '请选择一个菜单！',
  lab_theMenuHaveChildren: '当前菜单下有子菜单，请先删除子菜单！',
  MenuManagementList_checkGradeList: [{
    id: 1,
    name: '全部人员'
  }, {
    id: 2,
    name: '仅授权人员'
  }, {
    id: 3,
    name: '仅开发者'
  }, {
    id: 4,
    name: '暂时弃用'
  }],
  MenuManagementList_sourceList: [{
    id: 1,
    name: '后台'
  }, {
    id: 2,
    name: 'mobileApp'
  }],

  /***************
  页面路径：	系统管理->菜单管理
  页面中文名称：	系统代码参数
  页面英文名称：	systemCodeParametersList
  ******************/
  btn_addModule: '添加模块',
  btn_addCode: '添加常用代码',
  btn_deleteNow: '删除当前选项',
  lab_moduleName: '模块名称',
  lab_moduleCode: '模块编码',
  lab_theCodeName: '代码名称',
  lab_codeCode: '代码编码',
  lab_optionCode: '选项代码',
  lab_optionValue: '选项值',
  lab_selectModule: '请选择一个模块！',
  lab_selectCode: '请选择一个选项！',
  lab_theModuleHaveChildren: '当前模块下有常用代码，请先删除常用代码！',
  lab_needFinishLastAdd: '请先完成上次添加操作！',

  /***************
  页面路径：	系统管理->职责管理-新建/编辑页面
  页面中文名称：	职责管理
  页面英文名称：	editResponsibility
  ******************/
  btn_returnResponsibilityList: '返回职责管理列表',
  lab_responsibilityCode: '职责编码',
  lab_responsibilityName: '职责名称',
  lab_responsibilityLevel: '等级',
  lab_opeateRange: '操作权限范围',
  lab_flag: '是否启用',
  lab_authorityType: '类别',
  lab_responsibilityOption: '类别选项',
  lab_responsibilityOptionList: '请至少添加一条职责选项',
  lab_responsibilityOptionName: '职责选项名',
  lab_responsibilityOptionValue: '职责选项值',
  lab_responsibilityOptionOperation: '添加职责选项',
  lab_responsibilityOptionDeleteWarning: '是否删除此选项?（删除后可能造成数据错误！）',
  EditResponsibility_gradeList: [{
      id: 1,
      name: '部分小区'
    },
    {
      id: 0,
      name: '所有小区'
    },
  ],
  EditResponsibility_opeateRangeList: [{
      id: 0,
      name: '开发者权限'
    },
    {
      id: 1,
      name: '管理员权限'
    },
  ],
  EditResponsibility_flagList: [{
      id: 1,
      name: '启用'
    },
    {
      id: 0,
      name: '未启用'
    },
  ],
  EditResponsibility_authorityTypeList: [{
      id: 1,
      name: '多选'
    },
    {
      id: 0,
      name: '单选'
    },
  ],
  /***************
  页面路径：	系统管理->角色管理-新建/编辑页面
  页面中文名称：	角色管理
  页面英文名称：	editRoleManagement
  ******************/
  btn_returnRoleManagementList: '返回角色管理列表',
  lab_roleManagementName: '角色名称',
  lab_roleManagementFlag: '是否启用',
  lab_roleManagementMunu: '管理菜单权限',
  lab_roleManagementAuthority: '管理职责权限',
  lab_roleManagementJob: '管理职务权限',
  EditRoleManagement_flagList: [{
      id: 1,
      name: '启用'
    },
    {
      id: 0,
      name: '未启用'
    },
  ],
  /***************
  页面路径：	系统管理->职务管理-新建/编辑页面
  页面中文名称：	职务管理
  页面英文名称：	editJobManagement
  ******************/
  btn_returnJobManagementList: '返回职务管理列表',
  lab_jobManagementName: '职务名称',
  lab_jobManagementFlag: '是否启用',
  EditJobManagement_flagList: [{
      id: 1,
      name: '启用'
    },
    {
      id: 0,
      name: '未启用'
    },
  ],
  /***************
  页面路径：	其他->平面图设置
  页面中文名称：	平面图设置
  页面英文名称：	planeLayoutList
  ******************/
  lab_addPlan: '添加平面图',
  lab_changePlan: '修改平面图',
  lab_planName: '平面图名称',
  btn_pointSet: '点位设置',
  lab_selOnePlz: '请至少标出一个点位',
  lab_downPoint: '点位地图下载',
  lab_ple_addPlanName: '请填写平面图名称',
  lab_returnPointSetting: '返回平面图管理',
  lab_ple_uploadPicture: '请上传图片',
  lab_fileMoreThanCount: '文件超出个数',

  /***************
  页面路径：	其他->平面图设置->巡检路线设置
  页面中文名称：	设置
  页面英文名称：	planeLayoutList
  ******************/
  lab_addPoint: '*双击鼠标左键添加点位，添加前先选择一个巡检类型',
  lab_pointType: '巡 检 类 型',
  lab_pointName: '点位名称',
  lab_goawayType: '巡检类型',
  lab_goawayaway: '巡更点位顺序',
  lab_goawayGroup: '巡更分组',

  /***************
    页面路径：	报事模块->全项目报事信息 报事信息 全项目自动巡检报事
    页面中文名称：	全项目报事信息 报事信息 全项目自动巡检报事
    页面英文名称：	projectWideRepoInfoList repoInfoList fullprojectAutoInspecRepoList
  ******************/
  lab_propertyStatus: '处理状态',
  lab_hasPic: '是否有图',
  lab_mainSource: '报事来源',
  lab_isInTime: '是否24小时反馈',
  lab_isCheck: '是否审阅',
  lab_isInspect: '是否稽查工单',
  lab_haveParent: '是否有父工单',
  lab_haveChild: '是否有子工单',
  lab_complainFlagofType: '事件类别',
  lab_papereProperty: '工单属性',
  lab_patrolStandard: '请选择巡检标准',
  lab_stateCount: '已完成/异常/已跳过/总数量',
  lab_property0: '未接单',
  lab_property1: '我已接的工单',
  lab_property2: '派给我的工单',
  lab_property3: '我发起的工单',
  lab_property4: 'Ta人的工单',
  lab_isOvertime1: '超时的工单',
  lab_state5: '关闭的工单',
  lab_state5_1: '关闭的工单：正常关闭',
  lab_state6_1: '关闭的工单：非正常关闭',
  lab_isFollow2: '已回访的工单',
  lab_isCheck1: '审阅合格',
  lab_isCheck2: '审阅不合格',
  lab_isValet1: '代客报事',
  lab_isInspect1: '稽查报事',
  lab_isCopyToMe1: '抄送给我的工单',
  lab_haveChild1: '子工单',
  lab_haveParentId: '父工单',
  lab_property0Abbr: '未',
  lab_property1Abbr: '接',
  lab_property2Abbr: '派',
  lab_property3Abbr: '查',
  lab_property4Abbr: 'Ta',
  lab_isOvertime1Abbr: '超',
  lab_state5Abbr: '关',
  lab_state5Abbr_1: '关',
  lab_state6Abbr_1: '关',
  lab_isFollow2Abbr: '访',
  lab_isCheck1Abbr: '合格',
  lab_isCheck2Abbr: '不合格',
  lab_isValet1Abbr: '代',
  lab_isInspect1Abbr: '稽',
  lab_isCopyToMe1Abbr: '抄',
  lab_haveChild1Abbr: '子',
  lab_haveParentIdAbbr: '父',
  lab_paperBoard: '看板报事',
  btn_addMaintain: '后台报事',
  btn_backMaintain: '返回报事信息',
  lab_isValet: '是否代客报事',
  lab_isRequireDigitalSignature: '是否开启电子签名',
  lab_remarkSupply: '补单备注',
  lab_inspectionStandard: '巡检标准',
  lab_inspectionDevice: '巡检设备',
  lab_standardName: '标准名称',
  lab_standardMethod: '检查方法',
  lab_standardImg: '图片',
  lab_inspectionStandardList: '巡检标准列表',
  lab_inspectionDeviceList: '巡检设备列表',
  lab_inspectionStandardPreview: '巡检标准预览',
  lab_patrol_point_order: '巡更点位顺序',
  lab_patrol_point_group: '巡更分组',
  lab_patrol_point: '点位图',
  lab_Patrol_Preview: '巡检点位预览',
  lab_Explain: '说明',
  lab_isEagleEye: '是否鹰眼报事',
  lab_isNeedSignin: '是否开启签到',
  MaintainsList: {
    propertyStatusList: [{
        name: '未接单',
        id: 0
      },
      {
        name: '接单',
        id: 1
      },
      {
        name: '派单',
        id: 2
      },
      {
        name: '自查',
        id: 3
      },
      {
        name: 'Ta',
        id: 4
      }
    ],
    hasPicList: [{
        name: '无图',
        id: 0
      },
      {
        name: '有图',
        id: 1
      }
    ],
    mainSourceList: [{
        name: '后台报事',
        id: 1
      },
      {
        name: '业主APP报事',
        id: 2
      },
      {
        name: '物业APP报事',
        id: 3
      },
      {
        name: 'GBA设备报事',
        id: 5
      },
      {
        name: '看板报事',
        id: 6
      },
      {
        name: '小程序报事',
        id: 7
      },
      {
        name: '扫码报事',
        id: 11
      },
      {
        name: '合同报事',
        id: 13
      },
      {
        name: '资源点位报事',
        id: 14
      }
    ],
    isInTimeList: [{
        name: '未反馈',
        id: 0
      },
      {
        name: '24小时内反馈',
        id: 1
      },
      {
        name: '24小时内未反馈',
        id: 2
      }
    ],
    isCheckList: [{
        name: '未审阅',
        id: 0
      },
      {
        name: '合格',
        id: 1
      },
      {
        name: '不合格',
        id: 2
      },
      {
        name: '优秀',
        id: 4
      }
    ],
    isInspectList: [{
        name: '否',
        id: 0
      },
      {
        name: '是',
        id: 1
      }
    ],
    haveParentList: [{
        name: '否',
        id: 0
      },
      {
        name: '是',
        id: 1
      }
    ],
    haveChildList: [{
        name: '否',
        id: 0
      },
      {
        name: '是',
        id: 1
      }
    ],
    gradeEvaluationList: [{
        name: '优',
        id: 1
      },
      {
        name: '良',
        id: 2
      }
    ],
  },
  /***************
   页面路径：	报事模块->400报事信息
   页面中文名称：	400报事信息
   页面英文名称：	400NewspaperInfoList
   ******************/
  lab_complaintPraiseType2: '请选择事件类别',
  lab_complaintPraiseType3: '请选择事件类别分类',
  addNewspaperInfoListBtn: '400后台补单',
  lab_workorder: '工单完结情况',
  lab_isOvertime: '是否超时',
  lab_evaluate: '满意度',
  lab_orderstate: '工单状态',
  lab_complainFlag: '请选择事件性质',
  pla_spaperInfokey: '手机号,ID,内容',
  pla_spaperInfostaffName: '接单人',
  pla_spaperInfosendName: '报单人',
  lab_floorName: '请选择楼号',
  lab_unitName: '请选择单元号',
  lab_roomName: '请选择房间号',
  lab_firstLevel: '请选择报事一级分类',
  lab_secondLevel: '请选择报事二级分类',
  lab_thirdLevel: '请选择报事三级分类',
  lab_fourthLevel: '请选择报事四级分类',
  lab_fifthLevel: '请选择报事五级分类',
  lab_selete: '筛选',
  lab_paperusername: '报事用户',
  lab_papergarden: '小区',
  lab_papertype: '报事方式',
  lab_paperlast: '后台报事',
  lab_paperGBA: 'GBA设备报事',
  lab_paperauto: '自动巡检工单',
  lab_paperownerapp: '业主APP报事',
  lab_paperPropertyapp: '物业APP报事',
  lab_addback: '400后台补单',
  lab_wechatApplet: '小程序报事',
  lab_papertime: '报事时间',
  lab_paperhouse: '楼号',
  lab_paperunit: '单元号',
  lab_paperroom: '房间号',
  lab_papertypes: '报事类型',
  lab_papernatureofaffairs: '事件性质',
  lab_papercontent: '内容',
  lab_paperpeople: '接单人',
  lab_paperevaluate: '满意度',
  lab_paperenovaluate: '不满意',
  lab_paperevaluateyes: '满意',
  lab_paperevaluatesoso: '一般',
  lab_paperevaluateres: '未评价',
  lab_paperestate: '工单状态',
  lab_papereno: '无',
  lab_papereconsult: '咨询',
  lab_paperecomplaint: '投诉',
  lab_paperecommend: '表扬',
  lab_paperereportingstate: '报事状态',
  lab_papereconfirmed: '待确认',
  lab_paperesolved: '处理中',
  lab_paperefinsh: '已完成',
  lab_paperealreadyevaluated: '已评价',
  lab_paperecloses: '正常关闭',
  lab_paperenoclose: '非正常关闭',
  lab_fileCancel: '已撤销',
  lab_finishstatue: '完成情况',
  lab_photodetail: '图片详情',
  lab_route: '线路',
  lab_paperesolveds: '—待处理',
  lab_paperealreadyevaluateds: '—待评价',
  lab_alerypaperealreadyevaluateds: '—已评价',
  lab_nofinish: '未完成',
  lab_aleryfinish: '已完成',
  lab_unfinishs: '异常',
  lab_misss: '已跳过',
  lab_islist: '是否需要跳转到列表页面？',
  NewspaperInfoList: {
    workorderlist: [{
        name: '24小时内完成',
        id: 1
      },
      {
        name: '24小时内未完成',
        id: 2
      },
    ],
    isOvertimelist: [{
        name: '未超时',
        id: 0
      },
      {
        name: '超时',
        id: 1
      },
    ],
    evaluatelist: [{
        id: '0',
        name: '未评价'
      },
      {
        id: '1',
        name: '好评'
      },
      {
        id: '2',
        name: '中评'
      },
      {
        id: '3',
        name: '差评'
      },
      {
        id: '4',
        name: '文字评价'
      }
    ],
    statelist: [{
        id: '1',
        name: '待确认'
      },
      {
        id: '2',
        name: '处理中'
      },
      {
        id: '3',
        name: '已完成'
      },
      {
        id: '4',
        name: '已评价'
      },
      {
        id: '5',
        name: '关闭'
      },
      {
        id: '6',
        name: '已关闭(非正常关闭)'
      },
      {
        id: '7',
        name: '已撤销'
      },
      {
        id: '8',
        name: '挂起'
      }
    ],
    complainFlaglist: [{
        id: '0',
        name: '报事'
      },
      {
        id: '1',
        name: '咨询'
      },
      {
        id: '2',
        name: '投诉'
      },
      {
        id: '3',
        name: '表扬'
      }
    ],
    refreshs: [{
        id: '1',
        label: '开启自动刷新'
      },
      {
        id: '2',
        label: '关闭自动刷新'
      },
      {
        id: '0',
        label: '刷新当前页面'
      }
    ]
  },
  /***************
  页面路径：	报事模块->400后台补单
  页面中文名称：	400后台补单
  页面英文名称：	400backgroundSupply
  ******************/
  btn_backgroundSupply: '返回400报事信息',
  btn_allMaintain: '返回全项目报事信息',
  btn_allMaintainQuartzJob: '返回全项目自动巡检报事',
  btn_maintainInfo: '返回报事信息',
  btn_liftManagementInfo: '返回电梯管理',
  lab_accessories: '上传附件',
  lab_groundSupplyAddress: '人员住址',
  lab_groundSupplytype: '报事分类',
  lab_groundSupplyuser: '报事用户',
  lab_groundSupplyphone: '报事电话',
  lab_groundSupplynature: '报事性质',
  lab_groundSupplycontext: '报事内容',
  lab_groundSupplychargePerson: '负责人',
  lab_groundSupplyreceivePerson: '接单人',
  lab_groundSupplycopyPerson: '抄送人',
  lab_groundtype: '事件类别',
  lab_groundtypes: '事件类别分类',

  /***************
   页面路径：	报事模块->查看报事信息 
   页面中文名称：	查看报事信息 
   页面英文名称：	400backgroundDetail
   ******************/

  btn_backgroundSupplychangetype: '变更报事类型',
  btn_backgroundSupplycancelMaintains: '转移工单',
  btn_normalMaintains: '延时工单',
  btn_followMaintains: '跟进工单',
  btn_followMaintainsres: '回访工单',
  btn_checkMaintains: '审阅工单',
  btn_closeMaintain: '关闭工单',
  btn_cancelComplain: '撤销投诉',
  lab_backgroundfilesCancel: '撤销投诉附件',
  lab_backgroundMaintainType1Name: '报事类型',
  lab_backgroundid: '工单编号',
  lab_backgroundty: '事件类别',
  lab_backgroundtypesj: '事件类别分类',
  lab_backgroundusername: '报事用户',
  lab_backgroundgarden: '小区',
  lab_backgroundmobile: '联系电话',
  lab_backgroundhouseName: '楼号',
  lab_backgroundunitName: '单元号',
  lab_backgroundroomName: '房间号',
  lab_backgroundcontent: '报事信息',
  lab_backgroundfilesBefore: '处理前图片',
  lab_backgroundfilesAfter: '处理后图片',
  lab_noPhotoCount: '无处理照片',
  lab_backgroundwithFilesBefore: '处理前附件',
  lab_backgroundwithFilesAfter: '处理后附件',
  lab_backgroundfilesFollow: '跟进回访图片',
  lab_backgroundwithFilesFollow: '跟进回访附件',
  lab_backgroundfilesNormal: '延时图片',
  lab_backgroundmaintainType1: '报事一级分类',
  lab_backgroundmaintainType2: '报事二级分类',
  lab_backgroundmaintainType3: '报事三级分类',
  lab_backgroundmaintainType4: '报事四级分类',
  lab_backgroundmaintainType5: '报事五级分类',
  lab_backgroundstate: '工单状态',
  lab_backgroundnormal: '工单类型',
  lab_backgrounddifficulty: '工单难易评价',
  lab_backgroundstaffId: '接单人员',
  lab_backgroundcheckerName: '处理人员',
  lab_backgroundoneEvaluation: '评价等级',
  lab_backgroundtwoEvaluation: '选择评价',
  lab_backgroundthreeEvaluation: '评价内容',
  lab_backgrounduri: '图片评价',
  lab_backgroundisCheck: '审阅状态',
  lab_backgroundfilesCheck: '审阅图片',
  lab_backgroundcheckInfo: '审阅备注',
  lab_backgroundleft: '工单的一生',
  lab_backgroundtime: '时间',
  lab_backgroundnat: '行为',
  lab_backgroundtext: '备注',
  btn_collapseOne: '处理工单',
  btn_collapseTwo: '强制派单',
  lab_backgroundreplyCon: '回复客户',
  lab_backgroundsendorders: '派单备注',
  lab_backgroundsendpeople: '分派人员',
  btn_sendorders: '派单',
  btn_orderreceiving: '接单',
  lab_backgroundInfo: '备注',
  lab_backgroundtexts: '评价',
  lab_backgroundhardyzshow: '是否对业主显示',
  lab_backgroundhardEvaluation: '难易等级评价',
  btn_finish: '处理完成',
  btn_print: '打印工单',
  lab_closetext: '关闭备注',
  lab_isclosetext: '是否正常关闭',
  titlegd: '关闭工单',
  titlesy: '审阅工单',
  lab_isread: '审阅意见',
  lab_readtext: '审阅备注',
  titleupdate: '变更报事类型',
  lab_updatetext: '修改原因',
  titleys: '延时工单',
  lab_delaytext: '延时原因',
  titlegj: '跟进工单',
  lab_appandtext: '跟进备注',
  lab_hftext: '回访备注',
  titlezy: '转移工单',
  lab_changetext: '转移原因',
  lab_changeto: '转移给',
  btn_withfiles: '附件下载',
  lab_comment: '评语',
  btn_appraise: '提交评价',
  lab_iscontent: '您好，报事已经收到，稍后将安排物业人员为您服务',
  lab_received_orde: '已接单',
  lab_dispatch_orde: '已派单',
  lab_comment_successful: '评论成功',
  lab_PL: '巡检线路完成进度',
  lab_PL_info: '巡检信息',
  lab_PL_time: '反馈时间',
  lab_PL_state: '状态',
  lab_PL_pointName: '点位',
  lab_PL_pointNameShow: '点位：',
  lab_Device: '巡检设备完成进度',
  lab_Patrol: '处理标准完成进度',
  lab_notreviewed: '未审阅',
  lab_qualified: '合格',
  lab_noqualified: '不合格',
  lab_Devices: '巡检设备',
  btn_finishs: '完成',
  btn_unfinishs: '异常',
  lab_Speed_progress: '进度：',
  lab_allStateCount: '总数量',
  lab_finishStateCount: '已完成数量',
  lab_errorStateCount: '异常数量',
  lab_missStateCount: '已跳过数量',
  lab_undoneStateCount: '未完成数量',
  NewspaperInfoDetail: {
    evaluationslist: [{
        id: 1,
        name: '好评'
      },
      {
        id: 2,
        name: '中评'
      }, {
        id: 3,
        name: '差评'
      }
    ],
    myshowlist: [{
        id: 1,
        name: '满意'
      },
      {
        id: 3,
        name: '不满意'
      }
    ],
    yzshowlist: [{
        id: 1,
        name: '是'
      },
      {
        id: 0,
        name: '否'
      }
    ],
    Conlist: ['您好，报事已经收到，稍后将安排物业人员为您服务', '您好，报事已经收到，物业人员将在30分钟内到达处理'],
    isreadlist: [{
        id: 1,
        name: '合格'
      },
      {
        id: 2,
        name: '不合格'
      },
    ],
    isNormalCloselist: [{
        id: 1,
        name: '是'
      },
      {
        id: 0,
        name: '否'
      },
    ],
    isNormalCloselist1: [{
        id: 1,
        name: '正常关闭'
      },
      {
        id: 0,
        name: '非正常关闭'
      },
      {
        id: 2,
        name: '挂起'
      },
    ],
    evaluationlist: [{
        id: 1,
        name: '非常轻松'
      },
      {
        id: 2,
        name: '比较简单'
      }, {
        id: 3,
        name: '一般'
      },
      {
        id: 4,
        name: '比较吃力'
      },
      {
        id: 5,
        name: '非常困难'
      }
    ]
  },

  /***************
  页面路径：	小区信息服务->物业周检问题
  页面中文名称：物业周检问题
  页面英文名称：propertyWeekInspect
  ******************/
  lab_quesContent: '问题内容',
  lab_quesPicture: '问题照片',
  lab_propertyReply: '物业回复',
  lab_replyPicture: '回复照片',
  /***************
  页面路径：	小区信息服务->电话信息
  页面中文名称：	电话信息
  页面英文名称：	teleInfos
  ******************/
  lab_addTel: '添加电话',
  lab_changeTelInfo: '修改电话信息',
  lab_telName: '名称',
  lab_tele: '电话',
  lab_serTime: '服务时间',
  lab_infoName: '电话信息的名称',
  lab_telNum: '电话号码',
  lab_telSerTime: '这个电话的服务时间',
  lab_defTel: '设为默认报事电话',
  lab_pleInputName: '请输入名称',
  lab_pleInputTel: '请输入电话',
  lab_pleInputSerTime: '请输入服务时间',
  /***************
  页面路径：	小区信息服务->问卷调查链接
  页面中文名称：	问卷调查链接
  页面英文名称：	questionnaireLinks
  ******************/
  btn_addQuesLink: '添加问卷调查链接',
  lab_stateLink: '状态',
  lab_quesCommunity: '所属小区',
  lab_pleInputLink: '请输入链接地址',
  lab_pleInputRLink: '请输入正确的链接地址',
  lab_pleInputTime: '请选择时间',
  btn_changeQuesLink: '修改问卷调查链接',
  lab_deadTime: '过期时间',
  QUESTIONNAIRELINKS: {
    TYPE: [{
        value: 1,
        label: '启用'
      },
      {
        value: 2,
        label: '停用'
      }
    ]
  },
  /***************
  页面路径：	小区信息服务->APP住户管理
  页面中文名称：	APP住户管理
  页面英文名称：	appHouseholdManages
  ******************/
  lab_RegTime: '注册时间：',
  lab_to: '至',
  lab_startDate: '开始日期',
  lab_endDate: '结束日期',
  lab_pleInputKeyOrTel: '输入关键字或手机号',
  lab_tags: '标签',
  lab_starHouseOwner: '明星业主',
  lab_setStarHouseOwner: '设为明星业主',
  lab_celStarHouseOwner: '取消明星业主',
  lab_allDoorDevicedId: '所有门禁',
  lab_accessAuthority: '门禁权限',
  lab_accessControlPeriod: '门禁有效期',
  lab_allLiftId: '所有电梯',
  lab_elevatorPermissions: '电梯权限',
  lab_elevatorAuthority: '电梯有效期',
  lab_elevatorAccess: '电梯地下权限',
  APPHOUSEHOLDMANAGE: {
    USERTYPE: [{
        value: '0',
        label: '身份'
      },
      {
        value: '1',
        label: '业主'
      },
      {
        value: '2',
        label: '家属'
      },
      {
        value: '3',
        label: '租客'
      }
    ],
    TAGS: [{
        value: '',
        label: '标签'
      },
      {
        value: '1',
        label: '正能量'
      },
      {
        value: '2',
        label: '负能量'
      },
      {
        value: '3',
        label: '宠物'
      },
      {
        value: '4',
        label: '党员'
      },
      {
        value: '5',
        label: '军属'
      },
      {
        value: '6',
        label: '政府机关'
      },
      {
        value: '7',
        label: '老人（60以上）'
      },
      {
        value: '8',
        label: '幼童（学龄前）'
      },
      {
        value: '9',
        label: '独居帮扶'
      },
      {
        value: '10',
        label: '汽车服务'
      },
      {
        value: '11',
        label: '休闲旅游'
      },
      {
        value: '12',
        label: '社区服务'
      },
      {
        value: '13',
        label: '创意家居'
      },
      {
        value: '14',
        label: '粮油调味'
      },
      {
        value: '15',
        label: '酒水饮料'
      },
      {
        value: '16',
        label: '方便速食'
      },
      {
        value: '17',
        label: '居家清洁'
      },
      {
        value: '18',
        label: '休闲食品'
      },
      {
        value: '19',
        label: '鲜食商品'
      },
      {
        value: '20',
        label: '冲饮茗茶'
      },
      {
        value: '21',
        label: '儿童文玩'
      },
      {
        value: '22',
        label: '个清洗护'
      },
      {
        value: '23',
        label: '数码家电'
      },
      {
        value: '24',
        label: '生鲜蔬果'
      },
      {
        value: '其它',
        label: '其它'
      }
    ],
  },
  /***************
  页面路径：	小区信息服务->APP积分管理
  页面中文名称：	APP积分管理
  页面英文名称：	appIntegralManages
  ******************/
  lab_Integral: '积分',
  lab_Remark: '备注',
  lab_Have: '当前积分：',
  lab_tip: '请输入正整数积分',
  lab_IntegralNum: '请输入积分',
  lab_integralTxt: '请输入备注',
  btn_editIntegral: '修改积分',
  addIntegral: '增加',
  lessenIntegral: '减少',
  IntegralLose: '积分查询失败',
  IntegralEditLose: '积分修改失败',
  NoMember: '会员不存在',

  /***************
  模块名称：	系统管理
  页面英文名称：	preHouseholdInfoManage
  ******************/
  lab_duties: '职务名称',
  btn_addDuty: '新增职务',
  lbl_duties_Name: '职务名称',
  lbl_duties_Flag: '状态',
  /***************
  页面路径：	小区信息服务->小区空置房管理
  页面中文名称：	小区空置房管理
  页面英文名称：	vacantHouseManagement
  ******************/
  btn_retHousrManage: '返回楼房管理',
  lab_housrId: '楼号',
  btn_changeHouseId: '修改楼号',
  btn_changeunitId: '修改单元号',
  btn_changeroomId: '修改房间号',
  lab_pleInputnum: '请输入此字段',
  lab_pleInputHouseId: '请输入楼号',
  lab_pleInputUnitId: '请输入单元号',
  lab_pleInputRoomId: '请输入房间号',
  /***************
  页面路径：	小区信息服务->租客审批
  页面中文名称：	租客审批
  页面英文名称：	tenantInfos
  ******************/
  lab_tenantName: '租客姓名',
  lab_tenantTel: '租客电话',
  lab_applicationTime: '申请时间',
  lab_ownerName: '业主姓名',
  lab_ownerTel: '业主电话',
  lab_bulid: '楼栋',
  lab_unit: '单元',
  lab_room: '房间',
  lab_idInfo: '身份证',
  btn_cof: '确认',
  btn_refuse: '拒绝',
  btn_alcof: '已确认',
  btn_alRefuse: '已拒绝',
  lab_pleInputRefReason: '请输入拒绝理由',
  lab_refReason: '拒绝理由',
  TENANTINFOS: {
    TYPE: [{
        value: '',
        label: '请选择状态'
      },
      {
        value: '0',
        label: '审批中'
      },
      {
        value: '1',
        label: '已通过'
      },
      {
        value: '2',
        label: '已拒绝'
      }
      /* ,
            {
              value: '3',
              label: '已支付未选择'
            },
            {
              value: '4',
              label: '已支付已选择'
            } */
    ]
  },

  /***************
  页面路径：	其他->打印二维码
  页面中文名称：	打印二维码
  页面英文名称：	printQRCodeList
  ******************/
  lab_Plan: '平面图',
  lab_Type: '类型',
  lab_Count: '数量',
  lab_pointQRCodeDown: '点位二维码列表',
  lab_seeQrCodes: '查看二维码',
  btn_pointDown: '点位下载',
  btn_pointMapDown: '点位地图下载',
  btn_pointSequenceSetting: '点位顺序设置',
  btn_patrolRouteSettings: '巡检路线设置',
  btn_addPointOrder: '添加顺序',
  btn_editPointOrder: '修改顺序',
  lbl_duties_id: '序号',
  lbl_duties_name: '顺序名称',
  lab_writeDuties_name: '请填写顺序名称',
  lab_pointOrder: '点位排序',
  lab_choosePointOrder: '请给点位排序',
  btn_returnprintQRCodeList: '返回打印二维码',
  btn_addPatrolRouteSettings: '添加巡检路线',
  lab_inputPointName: '请输入顺序名称',
  btn_returnPatrolRouteSettings: '返回巡检路线设置',

  /***************
  页面路径：	物业管理服务->物业人员管理
  页面中文名称：	物业人员管理
  页面英文名称：	propertyManageList
  ******************/
  btn_addpropertyManage: '添加物业人员',
  lbl_duties_note: '姓名',
  lbl_duties_mobile: '手机号',
  pla_accountOrname: '请输入手机号或姓名搜索',
  lab_propertyname: '职务-姓名',
  pla_propertyname: '请输入职务-姓名（例：经理 - 张三）',
  // 物业知识库检索列表
  btn_knowledge: '添加物业知识库问题',
  btn_knowledgeedit: '修改物业知识库问题',
  lab_fileSuccess: '上传文件成功',
  lbl_knowledge_gname: '所属小区',
  lbl_knowledge_ktName: '问题分类',
  lbl_knowledge_inputktName: '问题名称',
  lbl_knowledge_name: '问题',
  lbl_knowledge_answer: '答案',
  diaFormtype: '物业问题/项目问题',
  diaFormgardenId: '所属小区',
  diaFormtypeId: '问题分类',
  lab_uploadSuccess: '上传成功',
  diaFormname: '问题',
  diaFormanswer: '答案',
  lab_uploadModel: '下载模板',
  lab_outResult: '导出结果',
  lab_allType: '全部分类',
  btn_importpropertyManage: '导入物业人员',
  searchAndQueryOfPropertyKnowledgeBaseList: {
    gender: [{
        id: 1,
        name: '物业知识百问'
      },
      {
        id: 2,
        name: '项目知识百问'
      }
    ]
  },
  /***************
  页面路径：	物业管理服务->物业人员详情
  页面中文名称：	物业人员详情
  页面英文名称：	addpropertyManage
  ******************/
  btn_backaddpropertyManage: '返回物业人员列表',
  lab_gender: '性别',
  lab_review: '审阅权限',
  lab_typeManage: '管家身份',
  lab_dept: '部门',
  lab_workYears: '工龄',
  pla_workYears: '请输入工龄',
  lab_joinDate: '入职日期',
  lab_position: '选择职务',
  lab_station: '岗位属性',
  lab_permission: '权限分配',
  lab_note: '备注',
  pla_note: '请输入备注',
  lab_HouseUnit: '管家管辖区域',
  lab_Houselist: '区域列表',
  houseUnittitle: '楼号/单元',
  mobile_FALSE: '该手机号已注册！',
  check_garden: '请至少选择一个小区',
  lab_operationNum: '操作证号',
  lab_pla_operationNum: '请输入操作证号',
  propertyManage: {
    gender: [{
        id: 2,
        name: '男'
      },
      {
        id: 1,
        name: '女'
      }
    ],
    review: [{
        id: 1,
        name: '是'
      },
      {
        id: 0,
        name: '否'
      }
    ],
    type: [{
        id: 2,
        name: '是'
      },
      {
        id: 1,
        name: '否'
      }
    ]
  },

  /***************
  页面路径：	报事模块->全项目报事信息
  页面中文名称：	全项目报事信息列表
  页面英文名称：	projectWideRepoInfoList
  ******************/
  btn_WindeRepoInfo: '添加报事信息',
  lbl_windeRepoInfo_id: '序号',
  lbl_windeRepoInfo_user_nickName: '报事用户',
  lbl_windeRepoInfo_garden_name: '小区',
  lbl_windeRepoInfo_beginSource: '报事来源',
  lbl_windeRepoInfo_createTime: '报事时间',
  lbl_windeRepoInfo_garden_grids_houseName: '楼号',
  lbl_windeRepoInfo_garden_grids_unitName: '单元号',
  lbl_windeRepoInfo_garden_grids_roomName: '房间号',
  lbl_windeRepoInfo_maintainType1_name: '报事类型',
  lbl_windeRepoInfo_complainFlag: '事件类型',
  lbl_windeRepoInfo_property: '工单属性',
  lbl_windeRepoInfo_isCheck: '工单状态',
  lbl_windeRepoInfo_state: '接单人',
  lbl_windeRepoInfo_content: '内容',
  lbl_windeRepoInfo_evaluate: '满意度',

  /***************
  页面路径：	报事模块->抽审工单
  页面中文名称：	抽审工单列表
  页面英文名称：	trialOrderList
  ******************/
  btn_trialList: '添加抽审工单',
  lbl_trial_id: '序号',
  lbl_trial_user_nickName: '报事用户',
  lbl_trial_garden_name: '小区',
  lbl_trial_beginSource: '报事方式',
  lbl_trial_createTime: '报事时间',
  lbl_trial_garden_grids_houseName: '楼号',
  lbl_trial_garden_grids_unitName: '单元号',
  lbl_trial_garden_grids_roomName: '房间号',
  lbl_trial_maintainType1_name: '报事类型',
  lbl_trial_normal: '工单类型',
  lbl_trial_state: '工单状态',
  lbl_trial_staffId: '接单人',
  lbl_trial_content: '内容',
  lbl_trial_evaluate: '满意度',
  trialSelectvillageall: '请选择小区',
  trialNotesBtn: '抽审记录',
  trialFirstLevelTip: '请选择一级报事分类',
  trialSecondLevelTip: '请选择二级报事分类',
  trialThirdLevelTip: '请选择三级报事分类',
  trialMeetPeo: '请输入接单人或报单人',
  trialIsQuartzJob: '是否包含自动巡检工单',
  trialOrderName: '请输入抽审名称',
  chargeLeader: '选择负责人',
  trialWriteScale: '填写报事类型比例',
  trialCreate: '生成抽审工单',
  trialDetailBtn: '详情',
  trialPreviewTitle: '抽审预览',
  trialReportTitle: '报事类型比例',
  lab_trialCancelWarning: '本次抽审已取消，未生成抽审记录，如要保存请重新生成并点击抽审预览中的确定！',
  lab_trialTotalWarning: '比例之和应为100%',
  lab_trialNameWarning: '请输入抽审名称',
  lab_trialPeopleWarning: '请选择负责人',
  lab_trialSuccess: '操作成功',
  lbl_trial_beginSource_htbd: '后台补单',
  lbl_trial_beginSource_zdxjgd: '自动巡检工单',
  lbl_trial_beginSource_yzbs: '业主APP报事',
  lbl_trial_beginSource_wybd: '物业APP报事',
  lbl_trial_beginSource_htbs: '后台报事',
  lbl_trial_normal_zcgd: '正常工单',
  lbl_trial_normal_ysgd: '延时工单',
  lbl_trial_normal_zbgd: '质保工单',
  lbl_trial_state_dqr: '待确认',
  lbl_trial_state_wxz: '维修中',
  lbl_trial_state_ywc: '已完成',
  lbl_trial_state_ypj: '已评价',
  lbl_trial_state_zcgb: '正常关闭',
  lbl_trial_state_fzcgb: '非正常关闭',
  lbl_trial_state_ycx: '已撤销',
  lbl_trial_evaluate_bmy: '不满意',
  lbl_trial_evaluate_wpj: '未评价',
  lbl_trial_evaluate_my: '满意',
  lbl_trial_evaluate_yb: '一般',
  lbl_trial_form_gc: '工程',
  lbl_trial_form_kf: '客服',
  lbl_trial_form_zx: '秩序',
  lbl_trial_form_bj: '保洁',
  lbl_trial_form_lh: '绿化',
  trialList: {
    trialType: [{
        value: '0',
        label: '报事方式'
      },
      {
        value: '1',
        label: '后台补单'
      },
      {
        value: '2',
        label: '业主APP报事'
      },
      {
        value: '3',
        label: '物业APP报事'
      }
    ],
    trialIsQuartzJob: [{
        value: '0',
        label: '是'
      },
      {
        value: '1',
        label: '否'
      },
    ],
  },
  /***************
    页面路径：	报事模块->抽审工单->抽审记录
    页面中文名称：	抽审记录列表
    页面英文名称：	trialNotes
    ******************/
  back_trialList: '返回抽审工单',
  trialNotes_name: '抽审名称',
  trialNotes_write_name: '请输入抽审名称',
  trialNotes_leader: '负责人',
  trialNotes_write_leader: '请输入负责人',
  trialNotes_date: '抽审日期',
  trialNotes_total: '抽审数据总数',
  trialNotes_qualified: '合格数',
  trialNotes_unqualified: '不合格数',
  trialNotes_state: '状态',
  trialNotes_state_complete: '已完成',
  trialNotes_state_uncomplete: '未完成',
  /***************
  页面路径：	报事模块->抽审工单->抽审记录->抽审记录详情列表
  页面中文名称：	抽审记录详情列表
  页面英文名称：	trialDetailList
  ******************/
  back_trialNotes: '返回抽审记录',
  trialDetailList_garden: '小区',
  trialDetailList_user: '报事用户',
  trialDetailList_type: '报事方式',
  trialDetailList_type_yzbs: '业主报事',
  trialDetailList_type_htbs: '后台报事',
  trialDetailList_date: '报事时间',
  trialDetailList_normal: '报事类型',
  trialDetailList_normal_zcgd: '正常工单',
  trialDetailList_normal_ysgd: '延时工单',
  trialDetailList_normal_zbgd: '质保工单',
  trialDetailList_trialType: '工单类型',
  trialDetailList_state: '抽审状态',
  trialDetailList_state_dcs: '待抽审',
  trialDetailList_state_hg: '合格',
  trialDetailList_state_bhg: '不合格',

  /***************
  页面路径：	物业管理->检查标准
  页面中文名称：	检查标准列表
  页面英文名称：	InspectionStandardList
  ******************/
  btn_inspectionStandard: '添加巡检标准',
  lbl_inspection_id: '序号',
  lbl_inspection_name: '标准名称',
  lbl_inspection_typeName1: '一级分类',
  lbl_inspection_typeName2: '二级分类',
  lbl_inspection_typeName3: '三级分类',
  lbl_inspection_typeName4: '四级分类',
  lbl_inspection_typeName5: '五级分类',
  lbl_choose_inspection_typeName1: '请选择报事一级分类',
  lbl_choose_inspection_typeName2: '请选择报事二级分类',
  lbl_choose_inspection_typeName3: '请选择报事三级分类',
  lbl_choose_inspection_typeName4: '请选择报事四级分类',
  lbl_choose_inspection_typeName5: '请选择报事五级分类',
  lbl_inputInspection_name: '请输入标准名称',
  lbl_inspection_info: '检查方法',
  lbl_inspection_urls: '照片',
  lbl_isNecessaryPhotos: '是否必传照片',
  btn_backToInspection: '返回巡检标准管理',
  INSPECTIONSTANDARD: {
    TYPE: [{
        value: 0,
        label: '不需照片'
      },
      {
        value: 1,
        label: '需要照片'
      }
    ]
  },

  lbl_point: '分数',
  lbl_standardInfo: '调查方式及抽样标准',

  /***************
  页面路径：	物业管理->物业知识库分类管理
  页面中文名称：	物业知识库分类管理列表
  页面英文名称：	knowledgeBaseManagementList
  ******************/
  btn_knowledgeBaseAdd: '添加知识库分类',
  btn_knowledgeBaseedit: '修改知识库分类',
  lbl_knowledgeBase_gardenId: '物业/项目',
  lbl_propertyKnowledge: '物业知识百问',
  lbl_projectKnowledge: '项目知识百问',
  lbl_knowledgeBase_name: '分类名称',
  lbl_propertyCateORprojectCate: '物业分类/项目分类',
  PROPERTYKNOWLEDGE: {
    GENDER: [{
        id: 1,
        name: '物业知识百问'
      },
      {
        id: 2,
        name: '项目知识百问'
      }
    ]
  },
  /***************
  页面路径：	物业管理->电梯管理
  页面中文名称：	电梯管理列表
  页面英文名称：	liftManagementList
  ******************/
  btn_liftManagementAdd: '添加电梯列表',
  lbl_liftManagement_id: '序号',
  lbl_liftManagement_userName: '报事用户',
  lbl_liftManagement_garden_name: '小区',
  lbl_liftManagement_beginSource: '报事方式',
  lbl_liftManagement_createTime: '报事时间',
  lbl_liftManagement_garden_grids_houseName: '楼号',
  lbl_liftManagement_garden_grids_unitName: '单元号',
  lbl_liftManagement_garden_grids_roomName: '房间号',
  lbl_liftManagement_maintainType1_name: '报事类型',
  lbl_liftManagement_normal: '工单类型',
  lbl_liftManagement_state: '工单状态',
  lbl_liftManagement_staffId: '接单人',
  lbl_liftManagement_content: '内容',
  lbl_liftManagement_evaluate: '满意度',
  lab_chooseSystemLevel1: '请选择电梯系统异常一级分类',
  lab_chooseSystemLevel2: '请选择电梯系统异常二级分类',
  lab_chooseBodyLevel1: '请选择电梯部件异常一级分类',
  lab_chooseBodyLevel2: '请选择电梯部件异常二级分类',
  lab_chooseBodyLevel3: '请选择电梯部件异常三级分类',
  lab_backgroundSupplement: '后台补单',
  lab_automaticPatrolWorkOrder: '自动巡检补单',
  lab_ownersRepor: '业主报事',
  lab_propertySupplement: '物业补单',
  lab_normalLift: '正常工单',
  lab_outlLift: '延时工单',
  lab_Revoked: '已撤销',

  /***************
  页面路径：	物业管理->电梯蓝牙设备管理
  页面中文名称：	电梯蓝牙设备管理列表
  页面英文名称：	elevBluetoothEquipManagesList
  ******************/
  btn_elevBluetoothEquipManagesAdd: '添加电梯设备',
  btn_elevBluetoothEquipManagesEdit: '修改电梯设备',
  lbl_elevBluetoothEquipManages_id: '序号',
  lbl_elevBluetoothEquipManages_macName: '电梯设备Mac地址',
  lbl_elevBluetoothEquipManages_name: '电梯名称',
  lbl_elevBluetoothEquipManages_houseName: '所属楼号',
  lbl_elevBluetoothEquipManages_unitName: '所属单元',
  diaFormgarden: '所属小区',
  diaFormhouse: '所属楼号',
  diaFormunit: '所属单元',
  lab_macName: '电梯设备名称',
  diaFormmacName: '电梯设备Mac地址',

  /***************
  页面路径：	物业管理->设备管理列表
  页面中文名称：	设备管理列表
  页面英文名称：	deviceManagementList
  ******************/
  lab_devieceManagement: '设备管理',
  btn_deviceManagementAdd: '添加设备',
  lbl_deviceManagement_name: '名称',
  lbl_deviceManagement_deviceNo: '编号',
  lbl_deviceManagement_param1: '主要参数1',
  lbl_deviceManagement_param2: '主要参数2',
  lbl_deviceManagement_param3: '说明',
  lbl_deviceManagement_count: '数量',
  lbl_deviceManagement_unit: '单位',
  btn_backDeviceManagement: '返回设备管理',
  lab_deviceLinkAddress: '设备链接地址',
  lbl_deviceManagement_useposition: '使用安装位置',
  lbl_deviceManagement_useUnitNo: '使用单位编号',
  lbl_deviceManagement_deviceOutNo: '设备出厂编号',
  lbl_deviceManagement_deviceRegNo: '设备注册代码',
  lbl_deviceManagement_keepUnit: '维保单位',
  lbl_deviceManagement_useUnitCode: '使用单位代码',
  lbl_deviceManagement_testUnit: '检验单位',
  lbl_deviceManagement_useRegInNo: '使用登记证编号',
  lbl_deviceManagement_yearTestDate: '年检日期',
  lbl_deviceManagement_nextYearTestDate: '下次年检日期',
  lbl_deviceManagement_deviceModel: '设备型号',
  lbl_deviceManagement_madeIn: '生产厂家',
  lbl_deviceManagement_startDate: '启用日期',
  lbl_deviceManagement_outDate: '出厂日期',
  lbl_deviceManagement_standardNo: '标准编号',
  lbl_deviceManagement_productNo: '产品编号',
  lbl_deviceManagement_turnCount: '转数',
  lbl_deviceManagement_current: '电流',
  lbl_deviceManagement_npsh: '必需汽蚀余量',
  lbl_deviceManagement_ratedVoltage: '额定电压',
  lbl_deviceManagement_controlMode: '控制方式',
  lbl_deviceManagement_carSize: '轿厢尺寸',
  lbl_deviceManagement_landing: '层站',
  lbl_deviceManagement_ratedOutput: '额定功率',
  lbl_deviceManagement_carrying: '载重',
  lbl_deviceManagement_speed: '速度',
  lbl_deviceManagement_powerFactor: '功率因数',
  lbl_deviceManagement_lift: '扬程',
  lbl_deviceManagement_flow: '流量',
  lbl_deviceManagement_pressure: '压力',
  lbl_deviceManagement_cubage: '容积',
  lbl_deviceManagement_weight: '重量',
  lbl_deviceManagement_position: '位置',
  lbl_deviceManagement_purpose: '用途',
  lbl_deviceManagement_scope: '范围',
  lbl_deviceManagement_note1: '备注1',
  lbl_deviceManagement_note2: '备注2',
  lbl_deviceManagement_note3: '备注3',
  lbl_isShowQr: '是否显示二维码',
  lab_deviceType: '设备类型',
  lab_registrar: '登录机关',
  lab_nextInspectionTime: '下次检验时间',
  lab_nextPlannedMaintenanceTime: '下次计划保养时间',

  /** **************
	页面路径：	系统管理->角色管理
  页面中文名称：	角色管理
  页面英文名称：	roleManagementList
  ******************/
  btn_addRole: '添加角色',
  lbl_roleManagementList_roleName: '角色名称',
  lbl_roleManagementList_jobList: '管理职务权限',
  lbl_roleManagementList_authorityList: '管理职责权限',
  lbl_roleManagementList_munuList: '管理菜单权限',
  lab_isdeleteRoleRecommendedPermissionsAvoidDataLoss: '是否删除此角色?(建议不使用的权限设成不启用,以免丢失数据!)',
  lab_privilegeDescription: '权限说明',
  lab_code: '编码',
  lab_permissionEncoding: '权限编码',
  lab_codeName: '名称',
  lab_permissionDisplayName: '权限显示名称',
  lab_cellRights: '小区权限',
  lab_dividedInto: '分为',
  lab_allDistricts: '所有小区',
  lab_and: '和',
  lab_comma: '，',
  lab_period: '。',
  lab_colon: '：',
  lab_someDistricts: '部分小区',
  lab_permissUsedCommunityLocated: '为当前用户所在小区都可使用此权限',
  lab_onlyAuthorizedUsePermissions: '为只有被授权的小区才可以使用权限',
  lab_operationAuthority: '操作权限',
  lab_developerPermissions: '开发者权限',
  lab_AdministratorRights: '管理员权限',
  lab_onlyDevelopersPermission: '为只有开发者可以分配此权限',
  lab_permissionOrdinaryAdministrators: '为普通管理员可以分配此权限',
  lab_contain: '包含',
  lab_category: '类别',
  lab_permissionsAre: '权限是',
  lab_radioSelectionType: '单选类型',
  lab_suchAsGender: '（如性别）',
  lab_asWelllAs: '以及',
  lab_multipleSelectionType: '多选类型',
  lab_suchAsIndividualPermissions: '（如各个权限分配）',
  lab_status: '状态',
  lab_whetherAvailable: '当前权限是否可用状态，不启用则不会出现在人员权限列表中',
  /***************
  页面路径：	系统管理->职责管理
  页面中文名称：	职责管理
  页面英文名称：	responsibilityManagementList
  ******************/
  btn_addResponsibility: '添加职责',
  lbl_responsibilityManagementList_code: '编码',
  lbl_responsibilityManagementList_name: '名称',
  lbl_responsibilityManagementList_grade: '部门权限',
  lbl_responsibilityManagementList_opeateRange: '操作权限',
  lbl_responsibilityManagementList_authorityType: '类别',
  lbl_responsibilityManagementList_flag: '状态',
  lab_isdeleteAuthorityRecommendedPermissionsAvoidDataLoss: '是否删除此权限?(建议不使用的权限设成不启用,以免丢失数据!)',
  lab_singleChoice: '单选',
  lab_multipleChoice: '多选',
  lab_notActivated: '未启用',
  lab_activated: '启用',
  /***************
  页面路径：	系统管理->职务管理
  页面中文名称：	职务管理
  页面英文名称：	jobManagementList
  ******************/
  lab_isdeleteJobRecommendedPermissionsAvoidDataLoss: '是否删除此职务?(建议不使用的权限设成不启用,以免丢失数据!)',
  btn_addJob: '添加职务',
  lbl_jobManagementList_Name: '职务名称',
  lbl_jobManagementList_Flag: '状态',
  /***************
  页面路径：	物业管理服务->资源台账
  页面中文名称：	资源台账
  页面英文名称：	jobManagementList
  ******************/
  btn_addLedger: '添加资源台账',
  lbl_resourceLedgerList_ItemName: '项目名称',
  lbl_resourceLedgerList_OneResourceType: '一级资源分类',
  lbl_resourceLedgerList_TwoResourceType: '二级资源分类',
  lbl_resourceLedgerList_PointPositionAttr: '点位属性',
  lbl_resourceLedgerList_State: '分类',
  lab_isdeleteResourceLedger: '确定要删除此资源台账吗？',
  lab_pleSelfirstsort: '请选择一级分类',
  lab_pleSelsecondsort: '请选择二级分类',
  lab_pleSelpointAttr: '请选择点位属性',
  lab_pleSelState: '请选择状态',

  /***************
  页面路径：	物业管理->门禁设备管理
  页面中文名称：	门禁设备管理
  页面英文名称：	accessControlEquipmentManagementList
  ******************/
  lab_addEquipment: '添加门禁设备',
  lab_editEquipment: '修改门禁设备',
  lab_searchEquipment: '门禁设备名称',
  lab_inputMacEquipment: '门禁设备Mac地址',
  lab_EquipmentName: '门禁名称',
  lab_EquipmentType: '门禁类型',
  /***************
  页面路径：	物业管理->门禁设备管理->子门禁
  页面中文名称：	子门禁设备管理
  页面英文名称：	doorDeviceSon
  ******************/
  lab_DoorDeviceSon: '子门禁',
  lab_DoorDeviceSonManege: '子门禁设备管理',
  lab_addDoorDeviceSon: '添加子门禁设备',
  lab_editDoorDeviceSon: '修改子门禁设备',
  lab_nameDoorDeviceSon: '子门禁名称',
  lab_numDoorDeviceSon: '编号',
  lab_ctDoorDeviceSon: '创建时间',
  lab_otDoorDeviceSon: '操作时间',
  /***************
	页面路径：	物业管理->门禁设备管理->星朗设备
	页面中文名称：	星朗设备管理
	页面英文名称：	xlDevice
  ******************/
  lab_xlDevice: '星朗',
  lab_xlDeviceManege: '星朗设备管理',
  lab_addXlDevice: '添加星朗设备',
  lab_xlDeviceName: '星朗设备名称',
  lab_xlDeviceNum: '星朗设备编号',
  accessControlEquipmentManagementList: {
    TYPE: [{
        value: 1,
        label: '普通'
      },
      {
        value: 2,
        label: '转闸'
      }
    ],
    DTYPE: [{
      value: 1,
      label: '门禁'
    },
    {
      value: 2,
      label: '考勤'
    },
    {
      value: 3,
      label: '巡检'
    }
  ],
    TYPE_WO: [{
      value: '000000',
      label: 'Uface系列'
    }]
  },
  /***************
  页面路径：	物业管理服务->员工转单
  页面中文名称：	员工转单
  页面英文名称：	employeeTransferOrder
  ******************/
  lab_transferOrderPersonnel: '转单人员办理',
  lab_transferOrderID: '转单人员ID',
  lab_pleSelTransferOrder: '请选择转单人',
  lab_forwarderID: '转接人员ID',
  lab_pleSelTransferForwarder: '请选择转接人',
  btn_handle: '办理',
  lab_transferOrderPersonnelHandleSuc: '转单人员办理成功',
  lab_transfereeCannotSame: '转单人员不能同为转接人员',
  /***************
  页面路径：	物业管理服务->员工离职
  页面中文名称：	员工离职
  页面英文名称：	employeeTurnover
  ******************/
  lab_forDepartureStaff: '离职人员办理',
  lab_departingStaff: '离职人员',
  lab_pleSeldepartingStaff: '请选择离职人',
  lab_forwarder: '转接人员',
  lab_departingStaffHandleSuc: '离职人员办理成功',
  lab_DepartStaffCannotSome: '离职人员不能同为转接人员',

  /***************
  页面路径：	物业管理->合同管理
  页面中文名称：	合同管理
  页面英文名称：	contractManageList
  ******************/
  CONTRACT: {
    STATES: [{
        id: 0,
        label: '未开始'
      },
      {
        id: 1,
        label: '进行中'
      },
      {
        id: 2,
        label: '已完成'
      },
      {
        id: 3,
        label: '已过期'
      }
    ],
    PAY: [{
        id: 0,
        label: '收款'
      },
      {
        id: 1,
        label: '付款'
      }
    ]
  },
  lab_download: '下载',
  lab_INGnow: '进行中',
  lab_noStart: '未开始',
  lab_outData: '已过期',
  lab_loginContract: '合同登记',
  lab_saveContract: '保存合同',
  lab_loginContractAndRemind: '登记并记账',
  lab_contractName: '项目名称',
  lab_contractChoose1: '请选择合同一级分类',
  lab_contractChoose2: '请选择合同二级分类',
  lab_contractChoose3: '请选择合同三级分类',
  lab_dataBegin: '签订日期：',
  lab_dataHT: '合同日期：',
  lab_dataZB: '质保日期：',
  lab_dataHTs: '合同日期',
  lab_dataZBs: '质保日期',
  lab_dataSK: '收付款时间',
  lab_chooseDept: '请选择部门',
  lab_contractType: '合同分类',
  lab_contractLName: '合同名称',
  lab_contractLOption: '合同状态',
  lab_contractLId: '合同编号',
  lab_contractLbeginTime: '合同日期（起）',
  lab_contractLEndTime: '合同日期（止）',
  lab_contractLCount: '分期笔数',
  lab_contractLPrice: '收/付款',
  lab_getMoney: '收款',
  lab_payMoney: '付款',
  lab_contractLevel: '合同状态',
  lab_contractCall: '设置提醒',
  lab_ourContractingUnit: '我方签约单位',
  lab_otherContractingUnit: '对方签约单位',
  lab_people: '负责人',
  lab_contract1: '合同一级分类',
  lab_contract2: '合同二级分类',
  lab_contract3: '合同三级分类',
  lab_contractLMoney: '合同金额',
  lab_positionLocation: '位置',
  lab_houseBig: '面积',
  lab_mathPosition: '物理位置',
  lab_guaranteeMoney: '质保金',
  lab_inotMoney: '合同期收入',
  lab_billingType: '开票类型',
  lab_billingImg: '票据图片',
  lab_enclosure: '附件',
  lab_returnContract: '返回合同管理',
  lab_signDate: '签订日期',
  lab_newContract: '新合同',
  lab_moreCall: '+更多提醒',
  lab_delCall: '-删除提醒',
  lab_callData: '提醒日期',
  lab_callPerson: '提醒人员',
  lab_callTel: '提醒手机号',
  lab_callContent: '提醒内容',
  lab_putRedmin: '设置提醒',
  lab_moreMessage: '附件',
  lab_DATA: 'yyyy 年 MM 月 dd 日',
  lab_recordPrice: '记账',
  lab_addRecord: '添加记账',
  lab_editRecord: '修改记账',
  lab_recordTime: '记账时间',
  lab_callMe: '提醒',
  lab_callMeReady: '已提醒',
  lab_selOne: '请至少选择一项合同',
  lab_lessOne: '记账前，请保证分期笔数至少为1',
  lab_callMeTime: '提醒时间',
  lab_recordPriceMoney: '交易金额',
  lab_chooseContract: '请选择合同状态',
  lab_choosePay: '请选择收款/付款',
  lab_countPrice: '分期笔数',
  lab_di: '第',
  lab_bi: '笔',
  lab_moneyTime: '交易时间',
  lab_returnList: '返回合同管理',
  /***************
  页面路径：	物业管理->工单分类管理
  页面中文名称：	工单分类管理
  页面英文名称：	maintaintypeManageList
  ******************/
  lab_maintaintypeManage: '工单分类管理',
  lab_addFirstType: '新增一级分类',
  lab_promptDelMaintainType: '该分类下存在子分类',
  lab_isDelMaintainType: '该分类下不能有子分类,确定删除吗？',
  lab_isShowByProperty: '是否物业可见',
  /***************
  页面路径：	hawkEyeOfPark->hawkEyeOfParkList
  页面中文名称：	园区鹰眼
  页面英文名称：	hawkEyeOfParkList
  ******************/
  lab_noEye: '所在小区暂时没有鹰眼',
  lab_jump: '发起报事',
  lab_cutImg: '鹰眼截图',
  lab_del_info: '已取消跳转',
  lab_jump_info: '是否跳转至报事页面',
  lab_chooseVideo: '请选择鹰眼位置',
  lab_chooseType: '请选择鹰眼分类',
  lab_eyeType: '鹰眼方式',
  lab_eyePlace: '鹰眼位置',
  SIZELIST: {
    LIST: [{
        id: 4,
        label: '四宫格'
      },
      {
        id: 9,
        label: '九宫格'
      }
    ]
  },
  /***************
  页面路径：	components->personalInfo
  页面中文名称：	个人信息
  页面英文名称：	personalInfo
  ******************/
  lab_loginAccount: '登录账号',
  lab_password: '密码',
  lab_frSixToFifteen: '6~15位密码',
  /***************
  页面中文名称：	表格下载功能
  ******************/
  lab_propertyStaffManagement: '物业人员管理',
  lab_appUsermanagement: 'APP住户管理',
  lab_originalHouseholdDataManagement: '原始住户数据管理',
  lab_equipmentManagement: '设备管理',
  lab_elevatorManagement: '电梯管理',
  lab_400ReportInformation: '400报事信息',
  lab_fullProjectReportInformation: '全项目报事信息',
  lab_fullProjectAutomaticInspectionReport: '全项目自动巡检报事',
  lab_reportInformation: '报事信息',
  /***************
    页面路径：	登录
    页面中文名称：登录
    页面英文名称：login
    ******************/
  lab_conpanyName: '润晟服务管理系统',
  lab_passwordLogin: '密码登录',
  lab_login: '登录',
  /***************
    页面路径：	trialOrder->trialOrderDetail
    页面中文名称：	抽审详情
    页面英文名称：	trialOrderDetail
    ******************/
  lab_propose: '建议',
  lab_resolution: '处理意见',
  lab_trialOrderresults: '处理结果',
  lab_Handler: '处理人员',
  lab_sampling: '处理抽审',
  lab_trialOrderuploadPhotograph: '抽审工单图片',
  lab_trialOrderfinsh: '已处理',
  trialOrderresultslist: [{
      id: 1,
      name: '待抽审'
    },
    {
      id: 2,
      name: '合格'
    },
    {
      id: 3,
      name: '不合格'
    },
    {
      id: 4,
      name: '优秀'
    }
  ],
  /***************
   页面路径：	appplot->appplotAdd
   页面中文名称：	app布局
   页面英文名称：	appplotAdd
   ******************/
  optionsModule: [{
      label: '活动',
      value: '活动'
    },
    {
      label: '众邻观点',
      value: '众邻观点'
    },
    {
      label: '服务评价',
      value: '服务评价'
    },
    {
      label: '热门活动',
      value: '热门活动'
    }
  ],
  /***************
   页面路径：	appletGood->appletsGoodList
   页面中文名称：	服务小站
   页面英文名称：	appletsGoodList
   ******************/
  lab_goodName: '商品名称',
  lab_good: '商品',
  lab_activity: '活动',
  lab_neigh: '邻里帮',
  lab_serverName: '服务名称',
  lab_serverUrl: '服务URL',
  lab_selectTab: '选择帖子',
  lab_selectActivity: '选择活动',
  lab_checkGardenCount: '您只能选择一个小区',
  lab_checkServerUrl: '请填写服务URL',
  lab_checkActivity: '请选择活动',
  lab_checkTab: '请选择帖子',

  /***************
  页面路径：	
  页面中文名称：	视频模块
  页面英文名称：	trainingVideoList
  ******************/
  btn_addVideo: '添加视频',
  btn_editVideo: '编辑视频',
  lab_videoName: '视频名称',
  lab_videoTypeName: '视频分类',
  lab_selectVideoType: '请选择视频分类',
  lab_videoURL: '视频链接名称',
  lab_inputVideoName: '请输入视频名称',
  lab_inputVideoNameTen: '视频名称最多30个字符',
  lab_inputvideoURL: '请输入视频链接名称',
  btn_videoTypeManagement: '视频分类管理',
  btn_videoAddShare: '视频分享',
  btn_videoCancelShare: '取消视频分享',
  lab_shared: '已分享',
  btn_createUrl: '生成链接',

  /***************
  页面路径：	
  页面中文名称：	考试模块
  页面英文名称：	trainingVideoList
  ******************/

  lab_questionLibrary: '试题库',
  lab_paperLibrary: '试卷库',
  lab_resultLibrary: '成绩库',
  lab_typeSetting: '分类设置',

  /***************
   页面路径：	
   页面中文名称：	视频分类管理模块
   页面英文名称：	trainingVideoTypeManagement
   ******************/
  btn_addFirstType: '新增一级分类',
  lab_videoRemindTitle: '该分类下不能有子分类,试题,试卷,确定删除吗？',
  lab_addVideoType: '新增分类',
  lab_editVideoType: '修改分类',
  lab_videoValidator: '输入不能为空',
  lab_addCancelVideo: '取消添加',
  lab_editCancelVideo: '取消修改',
  lab_delVideoMessage1: '删除分类时，该分类下不能有子分类',
  lab_delVideoMessage2: '该分类下存在视频，删除失败',

  /***************
  页面路径：	
  页面中文名称：	车场模块
  页面英文名称：	car
  ******************/
  lab_parkName: '车场名称',
  lab_pleParkName: '请输入车场名称',
  lab_carTtotalNum: '月租车位数',
  lab_carStoreNum: '储值车位数',
  lab_carTmpNum: '临时车位数',
  lab_carStoreAmount: '储值卡余额',
  lab_storeAmountList: '消费明细',
  lab_consume: '消费',
  lab_invest: '充值',
  lab_pleCarTtotalNum: '请输入总车位数',
  lab_tempIn: '临时车辆入场',
  lab_noGardenIn: '非本车场车辆入场',
  lab_isAllow: '开启',
  lab_noAllow: '关闭',
  lab_ycrc: '允许入场',
  lab_jjrc: '拒绝入场',
  lab_zlsrc: '转临时入场',
  lab_addPark: '添加车场',
  lab_changePark: '修改车场',
  lab_placeManage: '车位管理',
  lab_addPlace: '添加车位',
  lab_placeName: '车位名称',
  lab_placeArea: '车位面积',
  lab_plePlaceName: '请输入车位名称',
  lab_gateManage: '出入口管理',
  lab_gateType: '出入口类型',
  lab_gateEntry: '入口',
  lab_gateExit: '出口',
  lab_addGate: '添加出入口',
  lab_changeGate: '修改出入口',
  lab_carNum: '车辆管理',
  lab_addCarNum: '添加车辆',
  lab_changeCarNum: '修改车辆',
  lab_carNumber: '车牌号',
  lab_pleRightCarNum: '请输入正确的车牌号',
  lab_placeIsBind: '此车位已被其他车辆绑定',
  lab_controlPeriod: '有效期',
  lab_InTime: '入场时间',
  lab_OutTime: '出场时间',
  lab_InOutTime: '起止时间',
  lab_pleCarPark: '请选择车场',
  lab_pleInOutTime: '请选择起止时间',
  lab_In: '入场',
  lab_Out: '出场',
  lab_PayNoOut: '已缴费未出场',
  lab_PayOut: '已缴费已出场',
  lab_Other: '其他',
  lab_pleCarNum: '请输入车牌号',
  lab_inOutDeff: '停车时长',
  lab_ruleManage: '规则管理',
  lab_pleruleSearch: '请选择此项规则',
  lab_placeChildAndmother: '是否为子母车位',
  lab_gateName: '出入口名称',
  lab_parkType: '车场类型',
  lab_bePartOf: '属于',
  lab_bigPark: '大车场',
  lab_smallPark: '小车场',
  lab_pleBigSmallPark: '大小车场不应为同一车场',
  lab_cameraName: '摄像头名称',
  lab_cameraNum: '摄像头编号',
  lab_cameraType: '摄像头类型',
  lab_cameraMain: '主',
  lab_cameraAuxiliary: '辅',
  lab_screenType: '显示屏类型',
  lab_screen1: '微信智慧',
  lab_screen2: '柏朗斯',
  lab_screen3: '平安顺',
  lab_cameraUrl: '摄像头地址(公网)',
  lab_cameraUrlLan: '摄像头地址(内网)',
  lab_addCamera: '添加摄像头',
  lab_addGateErrMessage: '请 点 击 一 个 车 场 添 加 出 入 口',
  lab_addCameraErrMessage: '请 点 击 一 个 出 入 口 添 加 摄 像 头',
  lab_carDelChild: '当 前 项 下 有 子 项，请 先 删 除 子 项',
  lab_sdkz: '手动开闸',
  lab_xspsz: '显示屏配置',
  lab_yinliang: '音量',
  lab_sjtb: '时间同步',
  lab_hang1: '行1广告文字',
  lab_hang2: '行2广告文字',
  lab_hang3: '行3广告文字',
  lab_hang4: '行4广告文字',
  lab_kzsxtbh: '开闸摄像头编号',

  lab_endDay: '剩余天数',
  lab_monthlyRent: '月租车',
  lab_storeCar: '储值车',
  lab_temporary: '临时车',
  lab_isRepeat: '重复入场',
  lab_moreCar: '一位多车',
  lab_noInOut: '无入场放行',
  lab_fullOut: '车位满放行',
  lab_validDay: '剩余提醒天数',
  lab_temporaryCar: '临时车规则',
  lab_visitorTemporaryCar: '访客临时车',
  lab_confirmTemporaryCar: '人工确认',
  lab_tempFullIn: '车位满入场',
  lab_tempInSmallPark: '允许入小车场',
  lab_tempNoInOut: '无入场放行',

  lab_ownerPark: '所属车场',
  lab_ownerCarNum: '月租车车位数',
  lab_placeCount: '车位数',
  lab_carRentAndSale: '租售情况',
  lab_carLease: '出租',
  lab_carSell: '出售',
  lab_carStatus: '车辆状态',
  lab_carType: '车辆类型',
  lab_cancellation: '注销',

  lab_selPark: '请选择车场',
  lab_startTime: '起始时间',
  lab_stopTime: '终止时间',

  lab_carMonthlyCost: '月租车收费标准',
  lab_addMonthlyCost: '添加收费标准',
  lab_editMonthlyCost: '添加收费标准',
  lab_monthlyCostName: '收费标准名称',
  lab_monthlyCostAmount: '金额',
  lab_peoPass: '人工放行',
  lab_peoIn: '人工入场',
  lab_peoOut: '人工出场',
  lab_peoInSuccess: '人工入场成功',
  lab_peoOutSuccess: '人工出场成功',
  lab_checkGate: '请选择出入口',
  lab_writeRemark: '请输入备注',
  lab_writeCarNum: '请输入车牌号码',
  lab_gate: '出入口',
  lab_carParkControl: '车场监控',
  lab_temppayStandard: '标准规则',
  lab_temppayStandardDiscount: '商家优惠停车',
  lab_temppayStandardDerate: '商家停车减免',
  lab_temppayStandardGzh: '新能源规则',
  optionsCarStandard: [{
    label: '按小时收费',
    value: 1
  }],
  optionsCarStandard1: [{
    label: '按小时收费',
    value: 1
  }, {
    label: '按次收费',
    value: 2
  }],
  optionsCarStoreStandard: [{
    label: '按天计费（自然日）',
    value: 1
  }, {
    label: '按天计费（非自然日）',
    value: 2
  }, {
    label: '按小时计费',
    value: 3
  }],
  lab_costName: '规则名称',
  lab_inImagePath: '入场照片',
  lab_outImagePath: '出场照片',
  lab_errorCode0: '验证通过',
  lab_errorCode2: '无效车牌',
  lab_errorCode3: '车牌已过期',
  lab_errorCode4: '车牌未授权',
  lab_errorCode5: '非本停车场车辆',
  lab_errorCode6: '重复入场',
  lab_errorCode7: '车位已满',
  lab_errorCode8: '车场已满',
  lab_errorCode9: '没有找到入场车牌',
  lab_errorCode10: '物业确认',
  lab_errorCode11: '无入场记录放行',
  lab_errorCode12: '请缴费',
  lab_errorCode13: '假车牌',
  lab_errorCode14: '月租车转临时车',
  lab_errorCode15: '余额不足',
  lab_errorCode16: '人工放行',
  lab_errorCode17: '黑名单',
  lab_errorCode18: '手动开闸',
  /***************
  页面路径：	
  页面中文名称：	商城模块
  页面英文名称：	sklShop
  ******************/
  lab_configurationLabel: '配置标签',
  lab_tabWeight: '权重',
  lab_pleaseSelectGoodOrTag: '未选择商品或标签',
  lab_configurationBatch: '批量配置',
  lab_goodsDetail: '商品详情',
  lab_configurationBatchTips: '提示：批量配置将会清空原有标签',
  /***************
  页面路径：	
  页面中文名称：	收费模块
  页面英文名称：
  ******************/

  lab_configId: '费用项id',
  lab_feeTypeCdName: '收费项类型',
  lab_feeName: '收费项名称',
  lab_feeFlagName: '收费项标识',
  lab_billTypeName: '账单周期',
  lab_paymentCd: '付费类型',
  lab_paymentCycle: '缴费周期',
  lab_startTimes: '计费起始时间',
  lab_endTimes: '计费终止时间',
  lab_squarePrice: '计费单价',
  lab_additionalAmount: '附加/固定费用',
  btn_addfeeConfig: '添加收费项',
  lab_addfeeConfig: '添加收费项',
  lab_editfeeConfig: '修改收费项',
  cycle: '周期性',
  once: '一次性',
  repeatedly: '常用性',
  prepaid: '预付费',
  postpaid: '后付费',
  year: '每年1月1日',
  month: '每月1日',
  day: '每日',
  realTime: '实时',
  lab_computingFormula: '计费公式',
  lab_additionalAmount1: '附加费用',
  lab_additionalAmount2: '固定费用',
  lab_feeClassify: '收费分类',
  lab_isCreate: '是否确认创建?',
  lab_isExport: '是否确认导入？',
  lab_updateLift: '不同步梯控',
  lab_cycle: '计费周期',
  lab_mobileShow: '手机端显示',
  lab_instrumentNumber: '仪表号',
  feeClassifyRoomList: [{
      id: '888800010018',
      name: '住宅'
    },
    {
      id: '888800010019',
      name: '商业'
    },
    {
      id: '888800010020',
      name: '仓房'
    }
  ],
  feeClassifyCarList: [{
      id: '888800010022',
      name: '地下'
    },
    {
      id: '888800010021',
      name: '地上'
    },
  ],
  feePay: {
    lab_gardenName: '小区名称',
    lab_houseName: '楼号',
    lab_unitName: '单元号',
    lab_roomName: '房间号',
    lab_ownerName: '业主姓名',
    lab_mobile: '业主电话',
    lab_buildArea: '房屋面积',
    btn_createFeeConfig: '创建收费项',
    lab_locationTypeCd: '收费范围',
    lab_garden: '小区',
    lab_house: '楼栋',
    lab_unit: '单元',
    lab_room: '房屋',
    lab_room_owner: '业主',
    lab_feeConfigName: '收费项目',
    btn_roomDetail: '房屋费用',
    btn_carDetail: '车位费用',
    btn_createReceive: '生成应收',
    lab_period: '收费区间',
    lab_receiveConfig: '收费项目',
    btn_importData: '费用导入',
    lab_fee_object: '费用对象',
    btn_fee_import: '导入',
    lab_feeUseArea:'使用面积'

  },

  lab_amountOwed: '应收金额',
  lab_buildTime: '建账时间',
  lab_finishTime: '计费结束时间',
  lab_descriptionFee: '费用说明',
  lab_payMoneys: '收款',
  lab_stateName: '状态',
  lab_createMoney: '物业收费',
  lab_feeId: '费用ID',
  lab_saveFee: '提交收费',
  lab_dueDate: '到期时间',
  lab_customCycle: '自定义周期',
  lab_actualCycle: '实际周期',
  lab_resourRemark: '收费备注',
  lab_price: '单价',
  lab_totalFeePrice: '应收费用',
  lab_payMethod: '支付方式',
  lab_cash: '现金',
  lab_receivedAmount: '实收费用',
  lab_buildArea: '面积',
  lab_payFeeHistory: '缴费历史',
  lab_receiptNumber: '发票号',
  lab_feeBase: '缴费基数',
  lab_AmountYuan: '金额元',
  lab_feeStandard: '物业费标准元/㎡',
  lab_carStandard: '车位费标准元/月',
  lab_carPlaceCount: '车位数量',
  lab_balance: '余额',
  lab_isSaveFee: '是否确认提交？',
  lab_consumeAmount: '扣除费用',
  lab_convertProject: '转换项目',
  lab_convert: '转换费用',
  lab_feeSelectConfigName:'请选择收费项目',
  lab_feeLast:'尾差金额',
  lab_invoiceType:'自动开票',
  lab_isConsume:'是否扣除费用',
  lab_feeGenerate:'费用生成',
  lab_generate:'生成',
  lab_feeGeduct:'扣除费用',
  lab_feeDetail:'明细',
  lab_amountBalance:'账户余额',
  lab_isFeeLast:'调整尾差',
  lab_relatedTenants:'关联租户',
  lab_selectTenants:'选择租户',
  lab_tenants:'租户',
  lab_isDiscount:'缴费折扣',
  lab_discount:'折扣金额',
  payMethodList: [{
      id: '7',
      name: '现金'
    },
    {
      id: '2',
      name: 'POS机'
    },
    {
      id: '3',
      name: '二维码收款'
    },
    {
      id: '6',
      name: '微信支付'
    },
    {
      id: '13',
      name: '支付宝支付'
    },
    {
      id: '4',
      name: '联通支付'
    },
    {
      id: '1',
      name: 'APP线上支付'
    },
    {
      id: '5',
      name: '退款转物业费'
    },
    {
      id: '8',
      name: '押金转水电费'
    },
    {
      id: '9',
      name: '押金转物业费'
    },
    {
      id: '10',
      name: '一卡通付'
    },
    {
      id: '14',
      name: '转账回款'
    },
    {
      id: '11',
      name: '银行支票'
    },
    {
      id: '12',
      name: '预交冲抵'
    },
    {
      id: '15',
      name: '饱和调整'
    },
    {
      id: '16',
      name: '被继承'
    },
    {
      id: '17',
      name: '地产结算'
    },
    {
      id: '18',
      name: '手动减免'
    },
    {
      id: '19',
      name: '物业减免'
    },
    {
      id: '20',
      name: '应收减免'
    },
    {
      id: '21',
      name: '折扣'
    }
  ],
  payMethodListBack: [{
      id: '7',
      name: '现金'
    },
    {
      id: '2',
      name: 'POS机'
    },
    {
      id: '3',
      name: '二维码收款'
    },
    {
      id: '6',
      name: '微信支付'
    },
    {
      id: '13',
      name: '支付宝支付'
    },
    {
      id: '4',
      name: '联通支付'
    },
    {
      id: '1',
      name: 'APP线上支付'
    },
    {
      id: '5',
      name: '退款转物业费'
    },
    {
      id: '8',
      name: '押金转水电费'
    },
    {
      id: '9',
      name: '押金转物业费'
    },
    {
      id: '10',
      name: '一卡通付'
    },
    {
      id: '14',
      name: '转账回款'
    },
    {
      id: '11',
      name: '银行支票'
    },
    {
      id: '12',
      name: '预交冲抵'
    },
    {
      id: '15',
      name: '饱和调整'
    },
    {
      id: '16',
      name: '被继承'
    },
    {
      id: '17',
      name: '地产结算'
    },
    {
      id: '18',
      name: '手动减免'
    },
    {
      id: '19',
      name: '物业减免'
    },
    {
      id: '20',
      name: '应收减免'
    },
    {
      id: '21',
      name: '折扣'
    }
  ],
  payMethodReliefListBack: [
    {
      id: '5',
      name: '退款转物业费'
    },
    {
      id: '9',
      name: '押金转物业费'
    },
    {
      id: '12',
      name: '预交冲抵'
    },
    {
      id: '18',
      name: '手动减免'
    },
    {
      id: '19',
      name: '物业减免'
    },
    {
      id: '20',
      name: '应收减免'
    },
    {
      id: '21',
      name: '折扣'
    }
  ],
invoiceList: [{
    id: 1,
    name: '自动开票'
  },
  {
    id: 2,
    name: '手动开票'
  },
  {
    id: 3,
    name: '需要补票'
  },
  {
    id: 4,
    name: '成功补票'
  } 
],
feeUseAreaList: [{
    id: '1',
    name: '建筑面积'
  },
  {
    id: '2',
    name: '计费面积'
  },
],
lab_invoice: '开票标识',
  lab_payerObjName: '付费对象',
  lab_stateNames: '收费状态',

  // 缴费历史
  lab_detailId: '缴费ID',
  lab_cycles: '周期',
  lab_receivedAmountH: '实收金额',
  lab_createFeeHTime: '缴费时间',
  lab_startFeeHTime: '缴费起始时间',
  lab_endFeeHTime: '缴费结束时间',
  lab_returnFee: '退费',
  lab_returnFeeSuccess: '退费成功',
  lab_isreturnFeeSuccess: '是否退费',
  lab_isreturnFeeSuccess_can: '已取消退费',
  lab_isInvoice: '确认补票',
  lab_receiveArrearSelect: [{
      value: '0',
      label: '欠款合计>0'
    },
    {
      value: '1',
      label: '欠款合计=0'
    },
    {
      value: '2',
      label: '欠款合计<0'
    }
  ],

  // 应收明细
  lab_feePeriod: '收费区间',
  lab_oweStartTime: '欠费开始时间',
  lab_oweEndTimes: '欠费结束时间',
  lab_adjust: '调整',
  lab_adjustCause: '调整原因',

  // 应收查询
  lab_receiveCount: '应收金额合计',
  lab_receiveArrears: '应收欠款合计',
  lab_receivedCount: '已收金额合计',
  lab_feePeriodCount: '费用期间',
  lab_received: '已收金额',
  lab_receivedArrear: '应收欠款',
  lab_receivePeriod: '应收期间',
  lab_summary: '摘要',
  lab_suject: '科目',
  lab_creditAmount: '贷方金额',
  lab_debitAmount: '借方金额',

  // 报表管理
  lab_currentReceive: '本期应收',
  lab_currentReceived: '实收本期',
  lab_currentArrear: '本期欠款',
  lab_currentRate: '本期收缴率',
  lab_currentYearPast: '本年往期费用',
  lab_currentYearReceivedPast: '实收本年往期',
  lab_currentYearPastArrear: '本年往期欠款',
  lab_currentYearPastRate: '本年往期收缴率',
  lab_currentYearReceive: '本年应收',
  lab_currentYearReceived: '本年实收',
  lab_currentYearArrear: '本年欠款',
  lab_currentYearRate: '本年收缴率',
  lab_yearPastReceive: '往年应收',
  lab_yearPastReceived: '实收往年',
  lab_yearPastArrear: '往年欠款',
  lab_yearPastRate: '往年收缴率',
  lab_thisArrears: '当前欠款',
  lab_thisArrearsTime: '本年欠款时间',
  lab_pastArrears: '往期欠款',
  lab_arrearsTime: '欠款时间',
  lab_yearPastReceive: '往年陈欠',
  lab_yearPastReceived: '实收往年陈欠',
  lab_targetRate: '目标值率',
  lab_deviationRate: '偏差率',
  lab_deviationAmount: '偏差金额',
  /***************
  页面路径：	
  页面中文名称：	车位摇号审批
  页面英文名称：
  ******************/
  lab_urlContract: '房产证',
  lab_drivingBook: '行车本',
  lab_marriageCertificate: '结婚证',
  lab_familyRegister: '户口本',
  lab_paidNotSel: '已支付未选择',
  lab_paidSel: '已支付已选择',
  lab_parkingNumber: '车位号',
  lab_refusalCause: '拒绝原因',
  lab_payOrder: '商户订单号',
  lab_Prompt1: '手机号和房间号已登记',
  lab_Prompt2: '手机号已登记',
  lab_Prompt3: '房间号已登记',
  lab_dePointItem: '扣分项',
  lab_dePoint: '扣分值',
  /***************
   页面路径：	
   页面中文名称：	外拓信息
   页面英文名称：
   ******************/
  lab_biddingDate: '招标日期',
  lab_dateFw: '服务期限',
  lab_dateFwStart: '服务日期(起)',
  lab_dateFwEnd: '服务日期(止)',
  lab_locationArea: '区域名称',
  lab_projectName: '项目名称',
  lab_managementFormat: '管理业态',
  lab_agentMechanism: '代办机构',
  lab_biddingAmount: '招标总价',
  lab_outSideZbzt: '招标状态',
  lab_returnOutSide: '返回外拓信息',
  lab_newOutSide: '新增外拓信息',
  lab_winUnit: '中标单位',
  lab_winPrice: '中标价格',
  lab_payPrice: '订单金额',
  ple_payPrice: '请输入订单金额',
  lab_buyNum: '购买数量',
  ple_buyNum: '请输入购买数量',
  lab_skuInfo: '订单详情',
  ple_skuInfo: '请输入订单详情',
  /***************
  页面路径：	
  页面中文名称：	视频管理
  页面英文名称：
  ******************/
  btn_backToTriningVideo: '返回视频管理列表',
  venue: {
    btn_addVenueType: '添加类型',
    label_venueName: '资源名称',
    label_resourceType: '一级类型',
    tip_resourceName: '请输入类型名称',
    label_secResourceType: '二级类型',
    btn_addVenueType_first: '添加一级资源类型',
    title_editVenueType_first: '修改一级资源类型',
    btn_back_first: '返回一级资源类型',
    btn_addVenueType_sec: '添加二级资源类型',
    title_editVenueType_sec: '修改二级资源类型',
    btn_addVenue: '添加资源点位',
    btn_back_venue_management: '返回资源点位管理',
    label_customNo: '点位编号',
    tip_input_customNo: '请输入编号',
    label_customName: '点位名称',
    tip_input_customName: '请输入名称',
    label_attribute: '点位属性',
    tip_select_attribute: '请选择点位属性',
    tip_input_area: '请输入面积',
    tip_select_firstResource: '请选择一级类型',
    tip_select_secResource: '请选择二级类型',
    tip_select_startDate: '请选择开始日期',
    tip_select_endDate: '请选择截止日期',
    tip_select_health: '请选择健康状况',
    tip_select_status: '请选择营业状态',
    label_area: '面积',
    label_startDate: '开始日期',
    label_endDate: '截止日期',
    label_position: '位置',
    tip_input_position: '请输入位置',
    label_supplierName: '供应商名称',
    tip_input_supplierName: '请输入供应商名称',
    label_contactName: '负责人姓名',
    label_contactNumber: '负责人电话',
    tip_input_contactName: '请输入负责人姓名',
    tip_input_contactNumber: '请输入负责人联系电话',
    label_entrance: '出入口',
    tip_input_entrance: '请描述出入口',
    label_garden: '所属园区',
    label_house: '所属楼宇',
    tip_select_house: '请选择楼号',
    label_unit: '所属单元',
    tip_select_unit: '请选择单元',
    label_lift: '电梯名称',
    tip_input_lift: '请输入电梯名称',
    label_healthLevel: '健康状况',
    health: {
      level_good: '健康',
      level_normal: '良好',
      level_bad: '损坏'
    },
    label_status: '营业状态',
    status: {
      status_open: '营业',
      status_close: '未营业'
    },
    label_basePrice: '合作价格',
    tip_input_basePrice: '请输入合作价格',
    label_customPrice: '自营价格',
    tip_input_customPrice: '请输入自营价格',
    label_remark: '备注',
    tip_input_remark: '请输入备注'
  },
  /***************
  页面路径：	星朗门禁->发卡管理
  页面中文名称：	发卡管理
  页面英文名称：	manageCardList
  ******************/

  lbl_fkgl_cardNum: '卡号',
  lbl_fkgl_userName: '姓名',
  lbl_fkgl_mobile: '电话',
  lbl_fkgl_garden: '园区',
  lbl_fkgl_house: '楼号',
  lbl_fkgl_unit: '单元号',
  lbl_fkgl_room: '房间号',
  lbl_fkgl_cardType: '卡类型',
  lbl_fkgl_peopleType: '人员类型',
  lbl_fkgl_cardStatus: '卡状态',
  lbl_fkgl_cardType1: '类型',
  lbl_fkgl_cardStatus1: '状态',
  lbl_fkgl_cardValidityDate: '卡有效期限',
  lbl_fkgl_readCard: '读卡',
  lbl_fkgl_writeCard: '写卡',
  lbl_fkgl_initialCard: '初始化卡',
  lbl_fkgl_resetCard: '清卡信息',
  lbl_fkgl_abilityCard: '功能卡',
  lbl_fkgl_addCard: '添加卡片',
  lbl_fkgl_goDevice: '通行设备',
  lbl_fkgl_goFloor: '通行楼层',
  lbl_fkgl_userNameSelect: '请输入姓名',
  lbl_fkgl_cardTypeSelect: '请选择卡片类型',
  lbl_fkgl_goDeviceSelect: '请选择通行设备',
  lbl_fkgl_goFloorSelect: '请选择通行楼层',
  lbl_fkgl_cardValidityDateSelect: '请选择卡片有效期限',
  lbl_fkgl_cardExpirationTime: '过期时间',
  lbl_fkgl_cardCreatedTime: '创建时间',
  lbl_fkgl_cardWriteLastTime: '上次写卡时间',
  btn_returnManageCardList: '返回卡片管理',
  btn_loss: '挂失',
  btn_losscel: '取消挂失',
  DEMPARTMENT: {
    TYPE: [{
        value: '',
        label: '请选人员类型'
      },
      {
        value: '1',
        label: '业主'
      },
      {
        value: '2',
        label: '物业'
      },
      {
        value: '3',
        label: '商户'
      }
    ]
  },
  CARDTYPE: {
    TYPE: [{
        value: 0,
        label: '请选择卡类型'
      },
      {
        value: 1,
        label: '普通卡'
      },
      // {
      //   value: 2,
      //   label: '计次卡'
      // },
      {
        value: 3,
        label: '全通卡'
      },
      // {
      //   value: 4,
      //   label: '储值卡'
      // }
    ]
  },
  CARDSTATUS: {
    STATUS: [{
        value: '0',
        label: '请选择卡状态'
      },
      {
        value: '1',
        label: '已发卡'
      },
      {
        value: '2',
        label: '未发卡'
      },
      {
        value: '3',
        label: '过期卡'
      },
      {
        value: '4',
        label: '挂失卡'
      },
      {
        value: '5',
        label: '未同步卡'
      }
    ]
  },
  PASSFLOOR: {
    NUMBER: [{
        value: '1',
        label: '1（楼层）'
      },
      {
        value: '2',
        label: '2（楼层）'
      },
      {
        value: '3',
        label: '3（楼层）'
      },
      {
        value: '4',
        label: '4（楼层）'
      },
      {
        value: '5',
        label: '5（楼层）'
      },
      {
        value: '6',
        label: '6（楼层）'
      },
      {
        value: '7',
        label: '7（楼层）'
      },
      {
        value: '8',
        label: '8（楼层）'
      },
      {
        value: '9',
        label: '9（楼层）'
      },
      {
        value: '10',
        label: '10（楼层）'
      },
      {
        value: '11',
        label: '11（楼层）'
      },
      {
        value: '12',
        label: '12（楼层）'
      },
      {
        value: '13',
        label: '13（楼层）'
      },
      {
        value: '14',
        label: '14（楼层）'
      },
      {
        value: '15',
        label: '15（楼层）'
      },
      {
        value: '16',
        label: '16（楼层）'
      },
      {
        value: '17',
        label: '17（楼层）'
      },
      {
        value: '18',
        label: '18（楼层）'
      },
      {
        value: '19',
        label: '19（楼层）'
      },
      {
        value: '20',
        label: '20（楼层）'
      },
      {
        value: '21',
        label: '21（楼层）'
      },
      {
        value: '22',
        label: '22（楼层）'
      },
      {
        value: '23',
        label: '23（楼层）'
      },
      {
        value: '24',
        label: '24（楼层）'
      },
      {
        value: '25',
        label: '25（楼层）'
      },
      {
        value: '26',
        label: '26（楼层）'
      },
      {
        value: '27',
        label: '27（楼层）'
      },
      {
        value: '28',
        label: '28（楼层）'
      },
      {
        value: '29',
        label: '29（楼层）'
      },
      {
        value: '30',
        label: '30（楼层）'
      },
      {
        value: '31',
        label: '31（楼层）'
      },
      {
        value: '32',
        label: '32（楼层）'
      },
      {
        value: '33',
        label: '33（楼层）'
      },
      {
        value: '34',
        label: '34（楼层）'
      },
      {
        value: '35',
        label: '35（楼层）'
      },
      {
        value: '36',
        label: '36（楼层）'
      },
      {
        value: '37',
        label: '37（楼层）'
      },
      {
        value: '38',
        label: '38（楼层）'
      },
      {
        value: '39',
        label: '39（楼层）'
      },
      {
        value: '40',
        label: '40（楼层）'
      },
      {
        value: '41',
        label: '41（楼层）'
      },
      {
        value: '42',
        label: '42（楼层）'
      },
      {
        value: '43',
        label: '43（楼层）'
      },
      {
        value: '44',
        label: '44（楼层）'
      },
      {
        value: '45',
        label: '45（楼层）'
      },
      {
        value: '46',
        label: '46（楼层）'
      },
      {
        value: '47',
        label: '47（楼层）'
      },
      {
        value: '48',
        label: '48（楼层）'
      },
      {
        value: '49',
        label: '49（楼层）'
      },
      {
        value: '50',
        label: '50（楼层）'
      },
      {
        value: '51',
        label: '51（楼层）'
      },
      {
        value: '52',
        label: '52（楼层）'
      },
      {
        value: '53',
        label: '53（楼层）'
      },
      {
        value: '54',
        label: '54（楼层）'
      },
      {
        value: '55',
        label: '55（楼层）'
      },
      {
        value: '56',
        label: '56（楼层）'
      },
      {
        value: '57',
        label: '57（楼层）'
      },
      {
        value: '58',
        label: '58（楼层）'
      },
      {
        value: '59',
        label: '59（楼层）'
      },
      {
        value: '60',
        label: '60（楼层）'
      },
      {
        value: '61',
        label: '61（楼层）'
      },
      {
        value: '62',
        label: '62（楼层）'
      },
      {
        value: '63',
        label: '63（楼层）'
      },
      {
        value: '64',
        label: '64（楼层）'
      },

    ]
  },
  FLOORValue: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
    '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
    '21', '22', '23', '24', '25', '26', '27', '28', '29', '30',
    '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
    '41', '42', '43', '44', '45', '46', '47', '48', '49', '50',
    '51', '52', '53', '54', '55', '56', '57', '58', '59', '60',
    '61', '62', '63', '64'
  ],

  /***************
  页面路径：	星朗门禁->设备管理
  页面中文名称：	设备管理
  页面英文名称：	xlDoorDevice
  ******************/

  lbl_sbgl_deviceName: '设备名称',
  lbl_sbgl_deviceNum: '设备号',
  lbl_sbgl_deviceType: '设备类型',
  lbl_sbgl_selectDeviceType: '请选择设备类型',
  lbl_sbgl_deviceAdd: '添加设备',
  lbl_sbgl_deviceEdit: '修改设备',
  DEVICETYPE: {
    TYPE: [{
        value: 1,
        label: '园区门'
      },
      {
        value: 2,
        label: '单元门'
      },
      {
        value: 3,
        label: '电梯'
      },
    ]
  },
  /***************
  页面路径：	万洁->公司新闻
  页面中文名称：	公司新闻
  页面英文名称：	wjNewsList
  ******************/

  lbl_wj_newsTitle: '标题',
  lbl_wj_newsInfo: '正文',
  lbl_wj_newsDate: '发布时间',
  btn_wj_addNews: '新增',
  btn_wj_returnNews: '返回',
  newsTypes: [{
    value: 1,
    label: '疫情'
  }, {
    value: 2,
    label: '本地资讯'
  }, {
    value: 3,
    label: '国内要闻'
  }, {
    value: 99,
    label: '首页轮播'
  }],
  /***************
  页面路径：	万洁->技能培训
  页面中文名称：	技能培训
  页面英文名称：	wjTrainList
  ******************/

  lbl_wj_trainTitle: '培训标题',
  lbl_wj_trainInfo: '培训内容',
  lbl_wj_trainDate: '发布时间',
  btn_wj_addTrain: '新增技能培训',
  btn_wj_returnTrains: '返回技能培训',
  trainTypes: [{
    value: 1,
    label: '技能'
  }, {
    value: 2,
    label: '安全'
  }, {
    value: 3,
    label: '流程'
  }, {
    value: 4,
    label: '作业'
  }],
  /***************
  人脸识别
  ******************/
  btn_addWoAdmit: '创建识别主体',
  btn_delWoAdmit: '删除识别主体',
  lab_userName1: '识别主体名称',
  lab_waPhone: '联系方式',
  lab_admitGuid: '识别主体标识',
  /***************
  项目画像
  ******************/
  hasParty: [{
    value: 1,
    label: '是'
  }, {
    value: 2,
    label: '否'
  }], // 是否创建党组织
  partyType: [{
    value: 1,
    label: '党委'
  }, {
    value: 2,
    label: '党总支'
  }, {
    value: 3,
    label: '党支部'
  }], // 党组织类型
  legalPersonPapersType: [{
    value: 1,
    label: '身份证'
  }, {
    value: 2,
    label: '护照'
  }], // 法人证件类型
  administrativeRegion: [{
    value: 1,
    label: '和平区'
  }, {
    value: 2,
    label: '沈河区'
  }, {
    value: 3,
    label: '大东区'
  }, {
    value: 4,
    label: '皇姑区'
  }, {
    value: 5,
    label: '铁西区'
  }, {
    value: 6,
    label: '苏家屯区'
  }, {
    value: 7,
    label: '于洪区'
  }, {
    value: 8,
    label: '康平县'
  }, {
    value: 9,
    label: '法库县'
  }, {
    value: 10,
    label: '经济技术开发区'
  }, {
    value: 11,
    label: '新民市'
  }, {
    value: 12,
    label: '辽中县'
  }, {
    value: 13,
    label: '沈北新区'
  }, {
    value: 14,
    label: '浑南区'
  }], // 行政区域
  personType: [{
    value: 1,
    label: '法定代表人'
  }, {
    value: 2,
    label: '企业负责人'
  }, {
    value: 3,
    label: '其他管理人员'
  }], // 人员性质
  certificateType: [{
    value: 1,
    label: '身份证'
  }], // 证件类型
  contractType: [{
    value: 1,
    label: '前期物业服务合同'
  }, {
    value: 2,
    label: '后期物业服务合同'
  }], // 合同类别
  selectMode: [{
    value: 1,
    label: '公开方式'
  }, {
    value: 2,
    label: '协议方式'
  }, {
    value: 3,
    label: '邀请方式'
  }], // 物业选聘方式
  managementType: [{
    value: 1,
    label: '包干制'
  }, {
    value: 2,
    label: '酬金制'
  }], // 物业服务经营方式
  payType: [{
    value: 1,
    label: '物业管理费（不含电梯费）'
  }, {
    value: 2,
    label: '物业管理费（含电梯费）'
  }, {
    value: 3,
    label: '电梯使用费'
  }, {
    value: 4,
    label: '车位管理费'
  }], // 缴费类型
  payInfo: [{
    value: 1,
    label: '高层'
  }, {
    value: 2,
    label: '多层'
  }, {
    value: 3,
    label: '别墅'
  }, {
    value: 4,
    label: '商业网点'
  }, {
    value: 5,
    label: '洋房'
  }, {
    value: 6,
    label: '公寓'
  }, {
    value: 7,
    label: '写字间'
  }, {
    value: 8,
    label: '其他'
  }], // 缴费类型
  payInfoElevator: [{
    value: 9,
    label: '电梯费'
  }], // 缴费类型
  payInfoPark: [{
    value: 10,
    label: '地上车位'
  }, {
    value: 11,
    label: '地下车位'
  }, {
    value: 12,
    label: '地上车库'
  }, {
    value: 13,
    label: '地下车库'
  }], // 缴费类型
  projectType: [{
    value: 1,
    label: '住宅'
  }, {
    value: 2,
    label: '商住混合'
  }, {
    value: 3,
    label: '工业'
  }, {
    value: 4,
    label: '医院'
  }, {
    value: 5,
    label: '学校'
  }, {
    value: 6,
    label: '商务楼宇'
  }, {
    value: 7,
    label: '其他用途'
  }], // 项目类型
  yesorno: [{
    value: 1,
    label: '是'
  }, {
    value: 2,
    label: '否'
  }], // 是否
  managementModel: [{
    value: 1,
    label: '专业化物业服务'
  }, {
    value: 2,
    label: '保障型物业服务'
  }, {
    value: 3,
    label: '业主自治'
  }, {
    value: 4,
    label: '社区代管'
  }, {
    value: 5,
    label: '产权单位管理'
  }], // 管理模式
  doorPosition: [{
    value: 1,
    label: '东'
  }, {
    value: 2,
    label: '西'
  }, {
    value: 3,
    label: '南'
  }, {
    value: 4,
    label: '北'
  }], // 方位
  deviceType: [{
    value: 1,
    label: '变压器'
  }, {
    value: 2,
    label: '高压柜'
  }, {
    value: 3,
    label: '低压柜'
  }, {
    value: 4,
    label: '母线桥'
  }, {
    value: 5,
    label: '直流屏'
  }, {
    value: 6,
    label: '模拟屏'
  }, {
    value: 7,
    label: '高压电缆'
  }], // 配电设备类型
  FireControlDeviceTypeDeviceType: [{
    value: 1,
    label: '消防水池'
  }, {
    value: 2,
    label: '水泵'
  }, {
    value: 3,
    label: '消防监控室'
  }], // 消防设备类别
  matchType: [{
    value: 1,
    label: '地铁'
  }, {
    value: 2,
    label: '公交'
  }, {
    value: 3,
    label: '幼儿园'
  }, {
    value: 4,
    label: '小学'
  }, {
    value: 5,
    label: '超市'
  }, {
    value: 6,
    label: '丰巢'
  }], // 周边配套类别
}